/* eslint-disable max-len */
export const chainUrls = [
  {
    "id": "0x1",
    "name": "Ethereum",
    "rpcs": [
      {
        "platform": "ethereum-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://ethereum-rpc.publicnode.com",
        "title": "RPC Gateway to Ethereum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Ethereum network. Connect reliably to Web3 with ease!",
        "label": "Execution Layer",
        "showMetamask": true,
      },
      {
        "platform": "ethereum-teku-rpc",
        "short_name": "Beacon API",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://ethereum-beacon-api.publicnode.com",
        "title": "RPC Gateway to Ethereum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Ethereum network. Connect reliably to Web3 with ease!",
        "label": "Consensus Layer",
      },
      {
        "platform": "ethereum-sepolia-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Sepolia",
        "endpoint": "https://ethereum-sepolia-rpc.publicnode.com",
        "title": "RPC Gateway to Ethereum Sepolia",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Ethereum network. Connect reliably to Web3 with ease!",
        "label": "Execution Layer",
        "showMetamask": true,
      },
      {
        "platform": "ethereum-sepolia-teku-rpc",
        "short_name": "Beacon API",
        "network": "Testnet",
        "network_type": "Sepolia",
        "endpoint": "https://ethereum-sepolia-beacon-api.publicnode.com",
        "title": "RPC Gateway to Ethereum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Ethereum network. Connect reliably to Web3 with ease!",
        "label": "Consensus Layer",
      },
      {
        "platform": "ethereum-holesky-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Holesky",
        "endpoint": "https://ethereum-holesky-rpc.publicnode.com",
        "title": "RPC Gateway to Ethereum Holesky",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Ethereum network. Connect reliably to Web3 with ease!",
        "label": "Execution Layer",
        "showMetamask": true,
      },
      {
        "platform": "ethereum-holesky-teku-rpc",
        "short_name": "Beacon API",
        "network": "Testnet",
        "network_type": "Holesky",
        "endpoint": "https://ethereum-holesky-beacon-api.publicnode.com",
        "title": "RPC Gateway to Ethereum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Ethereum network. Connect reliably to Web3 with ease!",
        "label": "Consensus Layer",
      },
      {
        "platform": "ethereum-goerli-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Goerli",
        "endpoint": "https://ethereum-goerli-rpc.publicnode.com",
        "title": "RPC Gateway to Ethereum Goerli",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Ethereum network. Connect reliably to Web3 with ease!",
        "label": "Execution Layer",
        "showMetamask": true,
      },
      {
        "platform": "ethereum-goerli-teku-rpc",
        "short_name": "Beacon API",
        "network": "Testnet",
        "network_type": "Goerli",
        "endpoint": "https://ethereum-goerli-beacon-api.publicnode.com",
        "title": "RPC Gateway to Ethereum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Ethereum network. Connect reliably to Web3 with ease!",
        "label": "Consensus Layer",
      },
    ],
  },
  {
    "id": "0x38",
    "name": "BSC",
    "rpcs": [
      {
        "platform": "bsc-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://bsc-rpc.publicnode.com",
        "title": "RPC Gateway to BNB Smart Chain",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the BNB Smart Chain network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
      {
        "platform": "bsc-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "https://bsc-testnet-rpc.publicnode.com",
        "title": "RPC Gateway to BNB Smart Chain",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the BNB Smart Chain network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "0x89",
    "name": "Polygon",
    "rpcs": [
      {
        "platform": "polygon-heimdall-rpc",
        "short_name": "Heimdall RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://polygon-heimdall-rpc.publicnode.com:443",
        "title": "RPC Gateway to Polygon Heimdall",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Polygon network. Connect reliably to Web3 with ease!",
        "label": "Heimdall",
      },
      {
        "platform": "polygon-mumbai-heimdall-rpc",
        "short_name": "Heimdall RPC",
        "network": "Testnet",
        "network_type": "Mumbai",
        "endpoint": "https://polygon-mumbai-heimdall-rpc.publicnode.com:443",
        "title": "RPC Gateway to Polygon Heimdall",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Polygon network. Connect reliably to Web3 with ease!",
        "label": "Heimdall",
      },
    ],
  },
  {
    "id": "0xA86A",
    "name": "Avalanche",
    "rpcs": [],
  },
  {
    "id": "0x2105",
    "name": "Base",
    "rpcs": [
      {
        "platform": "base-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://base-rpc.publicnode.com",
        "title": "RPC Gateway to Base",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Base network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
      {
        "platform": "base-sepolia-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Sepolia",
        "endpoint": "https://base-sepolia-rpc.publicnode.com",
        "title": "RPC Gateway to Base",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Base network. Connect reliably to Web3 with ease!",
        "label": "Sepolia",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "0xA4B1",
    "name": "Arbitrum",
    "rpcs": [
      {
        "platform": "arbitrum-one-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "One",
        "endpoint": "https://arbitrum-one-rpc.publicnode.com",
        "title": "RPC Gateway to Arbitrum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Arbitrum network. Connect reliably to Web3 with ease!",
        "label": "One",
        "showMetamask": true,
      },
      {
        "platform": "arbitrum-nova-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "Nova",
        "endpoint": "https://arbitrum-nova-rpc.publicnode.com",
        "title": "RPC Gateway to Arbitrum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Arbitrum network. Connect reliably to Web3 with ease!",
        "label": "Nova",
        "showMetamask": true,
      },
      {
        "platform": "arbitrum-sepolia-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Sepolia",
        "endpoint": "https://arbitrum-sepolia-rpc.publicnode.com",
        "title": "RPC Gateway to Arbitrum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Arbitrum network. Connect reliably to Web3 with ease!",
        "label": "Sepolia",
        "showMetamask": true,
      },
      {
        "platform": "arbitrum-goerli-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Goerli",
        "endpoint": "https://arbitrum-goerli-rpc.publicnode.com",
        "title": "RPC Gateway to Arbitrum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Arbitrum network. Connect reliably to Web3 with ease!",
        "label": "Goerli",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "0xA",
    "name": "Optimism",
    "rpcs": [
      {
        "platform": "optimism-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://optimism-rpc.publicnode.com",
        "title": "RPC Gateway to Optimism",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Optimism network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
      {
        "platform": "optimism-sepolia-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Sepolia",
        "endpoint": "https://optimism-sepolia-rpc.publicnode.com",
        "title": "RPC Gateway to Optimism",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Optimism network. Connect reliably to Web3 with ease!",
        "label": "Sepolia",
        "showMetamask": true,
      },
      {
        "platform": "optimism-goerli-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Goerli",
        "endpoint": "https://optimism-goerli-rpc.publicnode.com",
        "title": "RPC Gateway to Optimism",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Optimism network. Connect reliably to Web3 with ease!",
        "label": "Goerli",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "0xFA",
    "name": "Fantom",
    "rpcs": [
      {
        "platform": "fantom-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://fantom-rpc.publicnode.com",
        "title": "RPC Gateway to Fantom",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Fantom network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
      {
        "platform": "fantom-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "https://fantom-testnet-rpc.publicnode.com",
        "title": "RPC Gateway to Fantom",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Fantom network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "0x19",
    "name": "Cronos",
    "rpcs": [
      {
        "platform": "cronos-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://cronos-rpc.publicnode.com:443",
        "title": "RPC Gateway to Cronos",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Cronos network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "cronos-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "cronos-grpc.publicnode.com:443",
        "title": "RPC Gateway to Cronos",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Cronos network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "columbus-5",
    "name": "Terra Classic",
    "rpcs": [
      {
        "platform": "terra-classic-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://terra-classic-rpc.publicnode.com:443",
        "title": "RPC Gateway to Terra Classic",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Terra Classic network. Connect reliably to Web3 with ease!",
        "label": "LCD",
      },
      {
        "platform": "terra-classic-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "terra-classic-grpc.publicnode.com:443",
        "title": "RPC Gateway to Terra Classic GRPC",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Terra Classic network. Connect reliably to Web3 with ease!",
        "label": "LCD",
      },
    ],
  },
  {
    "id": "kava_2222-10",
    "name": "Kava",
    "rpcs": [
      {
        "platform": "kava-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://kava-rpc.publicnode.com:443",
        "title": "RPC Gateway to Kava",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Kava network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "kava-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "kava-grpc.publicnode.com:443",
        "title": "RPC Gateway to Kava",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Kava network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0xCC",
    "name": "opBNB",
    "rpcs": [
      {
        "platform": "opbnb-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://opbnb-rpc.publicnode.com",
        "title": "RPC Gateway to opBNB",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the opBNB network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
      {
        "platform": "opbnb-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "https://opbnb-testnet-rpc.publicnode.com",
        "title": "RPC Gateway to opBNB",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the opBNB network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "injective-1",
    "name": "Injective",
    "rpcs": [
      {
        "platform": "injective-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://injective-rpc.publicnode.com:443",
        "title": "RPC Gateway to Injective",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Injective network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "injective-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "injective-grpc.publicnode.com:443",
        "title": "RPC Gateway to Injective",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Injective network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "injective-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "https://injective-testnet-rpc.publicnode.com:443",
        "title": "RPC Gateway to Injective",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Injective network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "injective-testnet-grpc",
        "short_name": "GRPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "injective-testnet-grpc.publicnode.com:443",
        "title": "RPC Gateway to Injective",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Injective network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x64",
    "name": "Gnosis",
    "rpcs": [
      {
        "platform": "gnosis-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://gnosis-rpc.publicnode.com",
        "title": "RPC Gateway to Gnosis",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Gnosis network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
      {
        "platform": "gnosis-chiado-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Chiado",
        "endpoint": "https://gnosis-chiado-rpc.publicnode.com",
        "title": "RPC Gateway to Gnosis",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Gnosis network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "cosmoshub-4",
    "name": "Cosmos",
    "rpcs": [
      {
        "platform": "cosmos-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://cosmos-rpc.publicnode.com:443",
        "title": "RPC Gateway to Cosmos",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Cosmos network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "cosmos-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "cosmos-grpc.publicnode.com:443",
        "title": "RPC Gateway to Cosmos",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Cosmos network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "osmosis-1",
    "name": "Osmosis",
    "rpcs": [
      {
        "platform": "osmosis-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://osmosis-rpc.publicnode.com:443",
        "title": "RPC Gateway to Osmosis",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Osmosis network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "osmosis-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "osmosis-grpc.publicnode.com:443",
        "title": "RPC Gateway to Osmosis",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Osmosis network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "dydx-mainnet-1",
    "name": "dYdX",
    "rpcs": [
      {
        "platform": "dydx-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://dydx-rpc.publicnode.com:443",
        "title": "RPC Gateway to dYdX",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the dYdX network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "dydx-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "dydx-grpc.publicnode.com:443",
        "title": "RPC Gateway to dYdX",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the dYdX network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "dydx-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "https://dydx-testnet-rpc.publicnode.com:443",
        "title": "RPC Gateway to dYdX",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the dYdX network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "dydx-testnet-grpc",
        "short_name": "GRPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "dydx-testnet-grpc.publicnode.com:443",
        "title": "RPC Gateway to dYdX",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the dYdX network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x1388",
    "name": "Mantle",
    "rpcs": [
      {
        "platform": "mantle-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://mantle-rpc.publicnode.com",
        "title": "RPC Gateway to Mantle",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Mantle network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
        "isArchive": true,
      },
    ],
  },
  {
    "id": "haqq_11235-1",
    "name": "HAQQ",
    "rpcs": [
      {
        "platform": "haqq-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://haqq-rpc.publicnode.com:443",
        "title": "RPC Gateway to HAQQ",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the HAQQ network. Connect reliably to Web3 with ease!",
        "isArchive": true,
      },
      {
        "platform": "haqq-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "haqq-grpc.publicnode.com:443",
        "title": "RPC Gateway to HAQQ",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the HAQQ network. Connect reliably to Web3 with ease!",
        "isArchive": true,
      },
    ],
  },
  {
    "id": "0x171",
    "name": "PulseChain",
    "rpcs": [
      {
        "platform": "pulsechain-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://pulsechain-rpc.publicnode.com",
        "title": "RPC Gateway to PulseChain",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the PulseChain network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
      {
        "platform": "pulsechain-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "https://pulsechain-testnet-rpc.publicnode.com",
        "title": "RPC Gateway to PulseChain",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the PulseChain network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "0x2329",
    "name": "Evmos",
    "rpcs": [
      {
        "platform": "evmos-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://evmos-rpc.publicnode.com:443",
        "title": "RPC Gateway to Evmos",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Evmos network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "evmos-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "evmos-grpc.publicnode.com:443",
        "title": "RPC Gateway to Evmos",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Evmos network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "evmos-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "https://evmos-testnet-rpc.publicnode.com:443",
        "title": "RPC Gateway to Evmos",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Evmos network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "evmos-testnet-grpc",
        "short_name": "GRPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "evmos-testnet-grpc.publicnode.com:443",
        "title": "RPC Gateway to Evmos",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Evmos network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "pacific-1",
    "name": "Sei",
    "rpcs": [
      {
        "platform": "sei-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://sei-rpc.publicnode.com:443",
        "title": "RPC Gateway to Sei",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Sei network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "sei-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "sei-grpc.publicnode.com:443",
        "title": "RPC Gateway to Sei",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Sei network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "sui-rpc",
    "name": "Sui",
    "rpcs": [
      {
        "platform": "sui-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://sui-rpc.publicnode.com",
        "title": "RPC Gateway to Sui",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Sui network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "sui-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Testnet",
        "endpoint": "https://sui-testnet-rpc.publicnode.com",
        "title": "RPC Gateway to Sui",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Sui network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "celestia",
    "name": "Celestia",
    "rpcs": [
      {
        "platform": "celestia-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://celestia-rpc.publicnode.com:443",
        "title": "RPC Gateway to Celestia",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Celestia network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "celestia-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "celestia-grpc.publicnode.com:443",
        "title": "RPC Gateway to Celestia",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Celestia network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "celestia-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Mocha",
        "endpoint": "https://celestia-mocha-rpc.publicnode.com:443",
        "title": "RPC Gateway to Celestia",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Celestia network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "celestia-testnet-grpc",
        "short_name": "GRPC",
        "network": "Testnet",
        "network_type": "Mocha",
        "endpoint": "celestia-mocha-grpc.publicnode.com:443",
        "title": "RPC Gateway to Celestia",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Celestia network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x504",
    "name": "Moonbeam",
    "rpcs": [
      {
        "platform": "moonbeam-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://moonbeam-rpc.publicnode.com",
        "title": "RPC Gateway to Moonbeam",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Moonbeam network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "kaiyo-1",
    "name": "Kujira",
    "rpcs": [
      {
        "platform": "kujira-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://kujira-rpc.publicnode.com:443",
        "title": "RPC Gateway to Kujira",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Kujira network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "kujira-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "kujira-grpc.publicnode.com:443",
        "title": "RPC Gateway to Kujira",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Kujira network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "juno-1",
    "name": "Juno",
    "rpcs": [
      {
        "platform": "juno-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://juno-rpc.publicnode.com:443",
        "title": "RPC Gateway to Juno",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Juno network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "juno-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "juno-grpc.publicnode.com:443",
        "title": "RPC Gateway to Juno",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Juno network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "phoenix-1",
    "name": "Terra",
    "rpcs": [
      {
        "platform": "terra-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://terra-rpc.publicnode.com:443",
        "title": "RPC Gateway to Terra",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Terra network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "terra-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "terra-grpc.publicnode.com:443",
        "title": "RPC Gateway to Terra",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Terra network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "fetchhub-4",
    "name": "Fetch.ai",
    "rpcs": [
      {
        "platform": "fetch-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://fetch-rpc.publicnode.com:443",
        "title": "RPC Gateway to Fetch.ai",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Fetch.ai network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "fetch-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "fetch-grpc.publicnode.com:443",
        "title": "RPC Gateway to Fetch.ai",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Fetch.ai network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "neutron-1",
    "name": "Neutron",
    "rpcs": [
      {
        "platform": "neutron-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://neutron-rpc.publicnode.com:443",
        "title": "RPC Gateway to Neutron",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Neutron network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "neutron-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "neutron-grpc.publicnode.com:443",
        "title": "RPC Gateway to Neutron",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Neutron network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x2B6653DC",
    "name": "TRON",
    "rpcs": [
      {
        "platform": "tron-rpc",
        "short_name": "HTTP",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://tron-rpc.publicnode.com",
        "title": "RPC Gateway to TRON",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the TRON network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "tron-solidity-rpc",
        "short_name": "Solidity HTTP",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://tron-solidity-rpc.publicnode.com",
        "title": "RPC Gateway to TRON",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the TRON network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "tron-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "tron-grpc.publicnode.com:443",
        "title": "RPC Gateway to TRON",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the TRON network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "tron-solidity-grpc",
        "short_name": "Solidity GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "tron-solidity-grpc.publicnode.com:443",
        "title": "RPC Gateway to TRON",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the TRON network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "akashnet-2",
    "name": "Akash Network",
    "rpcs": [
      {
        "platform": "akash-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://akash-rpc.publicnode.com:443",
        "title": "RPC Gateway to Akash Network",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Akash Network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "akash-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "akash-grpc.publicnode.com:443",
        "title": "RPC Gateway to Akash Network",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Akash Network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x44C",
    "name": "Dymension",
    "rpcs": [
      {
        "platform": "dymension-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://dymension-rpc.publicnode.com:443",
        "title": "RPC Gateway to Dymension",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Dymension network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "dymension-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "dymension-grpc.publicnode.com:443",
        "title": "RPC Gateway to Dymension",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Dymension network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "dymension-testnet-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Blumbus",
        "endpoint": "https://dymension-blumbus-rpc.publicnode.com:443",
        "title": "RPC Gateway to Dymension",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Dymension network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "dymension-testnet-grpc",
        "short_name": "GRPC",
        "network": "Testnet",
        "network_type": "Blumbus",
        "endpoint": "dymension-blumbus-grpc.publicnode.com:443",
        "title": "RPC Gateway to Dymension",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Dymension network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x15B38",
    "name": "Chiliz",
    "rpcs": [
      {
        "platform": "chiliz-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://chiliz-rpc.publicnode.com",
        "title": "RPC Gateway to Chiliz",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Chiliz network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
      {
        "platform": "chiliz-spicy-rpc",
        "short_name": "RPC",
        "network": "Testnet",
        "network_type": "Spicy",
        "endpoint": "https://chiliz-spicy-rpc.publicnode.com",
        "title": "RPC Gateway to Chiliz",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Chiliz network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "stride-1",
    "name": "Stride",
    "rpcs": [
      {
        "platform": "stride-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://stride-rpc.publicnode.com:443",
        "title": "RPC Gateway to Stride",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Stride network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "stride-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "stride-grpc.publicnode.com:443",
        "title": "RPC Gateway to Stride",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Stride network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "irishub-1",
    "name": "IRISnet",
    "rpcs": [
      {
        "platform": "iris-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://iris-rpc.publicnode.com:443",
        "title": "RPC Gateway to IRISnet",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the IRISnet network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "iris-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "iris-grpc.publicnode.com:443",
        "title": "RPC Gateway to IRISnet",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the IRISnet network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x505",
    "name": "Moonriver",
    "rpcs": [
      {
        "platform": "moonriver-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://moonriver-rpc.publicnode.com",
        "title": "RPC Gateway to Moonriver",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Moonriver network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "sentinelhub-2",
    "name": "Sentinel",
    "rpcs": [
      {
        "platform": "sentinel-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://sentinel-rpc.publicnode.com:443",
        "title": "RPC Gateway to Sentinel",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Sentinel network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "sentinel-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "sentinel-grpc.publicnode.com:443",
        "title": "RPC Gateway to Sentinel",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Sentinel network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "polkadot-rpc",
    "name": "Polkadot",
    "rpcs": [
      {
        "platform": "polkadot-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://polkadot-rpc.publicnode.com",
        "title": "RPC Gateway to Polkadot",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Polkadot network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "tenet_1559-1",
    "name": "Tenet",
    "rpcs": [
      {
        "platform": "tenet-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://tenet-rpc.publicnode.com:443",
        "title": "RPC Gateway to Tenet",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Tenet network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "tenet-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "tenet-grpc.publicnode.com:443",
        "title": "RPC Gateway to Tenet",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Tenet network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "shentu-2.2",
    "name": "Shentu",
    "rpcs": [
      {
        "platform": "shentu-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://shentu-rpc.publicnode.com:443",
        "title": "RPC Gateway to Shentu",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Shentu network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "shentu-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "shentu-grpc.publicnode.com:443",
        "title": "RPC Gateway to Shentu",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Shentu network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "crypto-org-chain-mainnet-1",
    "name": "Crypto.org Chain",
    "rpcs": [
      {
        "platform": "cro-chain-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://cro-chain-rpc.publicnode.com:443",
        "title": "RPC Gateway to Crypto.org Chain",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Crypto.org Chain network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "cro-chain-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "cro-chain-grpc.publicnode.com:443",
        "title": "RPC Gateway to Crypto.org Chain",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Crypto.org Chain network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "coreum-mainnet-1",
    "name": "Coreum",
    "rpcs": [
      {
        "platform": "coreum-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://coreum-rpc.publicnode.com:443",
        "title": "RPC Gateway to Coreum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Coreum network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "coreum-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "coreum-grpc.publicnode.com:443",
        "title": "RPC Gateway to Coreum",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Coreum network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "mantle-1",
    "name": "AssetMantle",
    "rpcs": [
      {
        "platform": "asset-mantle-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://asset-mantle-rpc.publicnode.com:443",
        "title": "RPC Gateway to AssetMantle",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the AssetMantle network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "asset-mantle-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "asset-mantle-grpc.publicnode.com:443",
        "title": "RPC Gateway to AssetMantle",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the AssetMantle network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "mars-1",
    "name": "Mars Protocol",
    "rpcs": [
      {
        "platform": "mars-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://mars-rpc.publicnode.com:443",
        "title": "RPC Gateway to Mars Protocol",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Mars Protocol network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "mars-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "mars-grpc.publicnode.com:443",
        "title": "RPC Gateway to Mars Protocol",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Mars Protocol network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "teritori-1",
    "name": "Teritori",
    "rpcs": [
      {
        "platform": "teritori-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://teritori-rpc.publicnode.com:443",
        "title": "RPC Gateway to Teritori",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Teritori network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "teritori-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "teritori-grpc.publicnode.com:443",
        "title": "RPC Gateway to Teritori",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Teritori network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "stargaze-1",
    "name": "Stargaze",
    "rpcs": [
      {
        "platform": "stargaze-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://stargaze-rpc.publicnode.com:443",
        "title": "RPC Gateway to Stargaze",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Stargaze network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "stargaze-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "stargaze-grpc.publicnode.com:443",
        "title": "RPC Gateway to Stargaze",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Stargaze network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "chihuahua-1",
    "name": "Chihuahua",
    "rpcs": [
      {
        "platform": "chihuahua-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://chihuahua-rpc.publicnode.com:443",
        "title": "RPC Gateway to Chihuahua",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Chihuahua network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "chihuahua-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "chihuahua-grpc.publicnode.com:443",
        "title": "RPC Gateway to Chihuahua",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Chihuahua network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "core-1",
    "name": "Persistence",
    "rpcs": [
      {
        "platform": "persistence-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://persistence-rpc.publicnode.com:443",
        "title": "RPC Gateway to Persistence",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Persistence network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "persistence-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "persistence-grpc.publicnode.com:443",
        "title": "RPC Gateway to Persistence",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Persistence network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "sifchain-1",
    "name": "Sifchain",
    "rpcs": [
      {
        "platform": "sifchain-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://sifchain-rpc.publicnode.com:443",
        "title": "RPC Gateway to Sifchain",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Sifchain network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "sifchain-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "sifchain-grpc.publicnode.com:443",
        "title": "RPC Gateway to Sifchain",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Sifchain network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "reb_1111-1",
    "name": "Rebus",
    "rpcs": [
      {
        "platform": "rebus-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://rebus-rpc.publicnode.com:443",
        "title": "RPC Gateway to Rebus",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Rebus network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "rebus-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "rebus-grpc.publicnode.com:443",
        "title": "RPC Gateway to Rebus",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Rebus network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x39",
    "name": "Syscoin",
    "rpcs": [],
  },
  {
    "id": "comdex-1",
    "name": "Comdex",
    "rpcs": [
      {
        "platform": "comdex-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://comdex-rpc.publicnode.com:443",
        "title": "RPC Gateway to Comdex",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Comdex network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "comdex-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "comdex-grpc.publicnode.com:443",
        "title": "RPC Gateway to Comdex",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Comdex network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "pirin-1",
    "name": "Nolus",
    "rpcs": [
      {
        "platform": "nolus-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://nolus-rpc.publicnode.com:443",
        "title": "RPC Gateway to Nolus",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Nolus network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "nolus-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "nolus-grpc.publicnode.com:443",
        "title": "RPC Gateway to Nolus",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Nolus network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "quicksilver-2",
    "name": "Quicksilver",
    "rpcs": [
      {
        "platform": "quicksilver-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://quicksilver-rpc.publicnode.com:443",
        "title": "RPC Gateway to Quicksilver",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Quicksilver network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "quicksilver-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "quicksilver-grpc.publicnode.com:443",
        "title": "RPC Gateway to Quicksilver",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Quicksilver network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "bitcanna-1",
    "name": "BitCanna",
    "rpcs": [
      {
        "platform": "bitcanna-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://bitcanna-rpc.publicnode.com:443",
        "title": "RPC Gateway to BitCanna",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the BitCanna network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "bitcanna-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "bitcanna-grpc.publicnode.com:443",
        "title": "RPC Gateway to BitCanna",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the BitCanna network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "0x142D",
    "name": "Bahamut",
    "rpcs": [
      {
        "platform": "bahamut-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://bahamut-rpc.publicnode.com",
        "title": "RPC Gateway to Bahamut",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Bahamut network. Connect reliably to Web3 with ease!",
        "showMetamask": true,
      },
    ],
  },
  {
    "id": "quasar-1",
    "name": "Quasar",
    "rpcs": [
      {
        "platform": "quasar-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://quasar-rpc.publicnode.com:443",
        "title": "RPC Gateway to Quasar",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Quasar network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "quasar-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "quasar-grpc.publicnode.com:443",
        "title": "RPC Gateway to Quasar",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Quasar network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "regen-1",
    "name": "Regen",
    "rpcs": [
      {
        "platform": "regen-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://regen-rpc.publicnode.com:443",
        "title": "RPC Gateway to Regen",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Regen network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "regen-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "regen-grpc.publicnode.com:443",
        "title": "RPC Gateway to Regen",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Regen network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "titan-1",
    "name": "RIZON",
    "rpcs": [
      {
        "platform": "rizon-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://rizon-rpc.publicnode.com:443",
        "title": "RPC Gateway to RIZON",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the RIZON network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "rizon-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "rizon-grpc.publicnode.com:443",
        "title": "RPC Gateway to RIZON",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the RIZON network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "axelar-dojo-1",
    "name": "Axelar",
    "rpcs": [
      {
        "platform": "axelar-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://axelar-rpc.publicnode.com:443",
        "title": "RPC Gateway to Axelar",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Axelar network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "axelar-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "axelar-grpc.publicnode.com:443",
        "title": "RPC Gateway to Axelar",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Axelar network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "omniflixhub-1",
    "name": "OmniFlix Network",
    "rpcs": [
      {
        "platform": "omniflix-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://omniflix-rpc.publicnode.com:443",
        "title": "RPC Gateway to OmniFlix Network",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the OmniFlix Network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "omniflix-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "omniflix-grpc.publicnode.com:443",
        "title": "RPC Gateway to OmniFlix Network",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the OmniFlix Network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "passage-1",
    "name": "Passage",
    "rpcs": [
      {
        "platform": "passage-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://passage-rpc.publicnode.com:443",
        "title": "RPC Gateway to Passage",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Passage network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "passage-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "passage-grpc.publicnode.com:443",
        "title": "RPC Gateway to Passage",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Passage network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "govgen-1",
    "name": "GovGen",
    "rpcs": [
      {
        "platform": "govgen-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://govgen-rpc.publicnode.com:443",
        "title": "RPC Gateway to GovGen",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the GovGen network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "govgen-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "govgen-grpc.publicnode.com:443",
        "title": "RPC Gateway to GovGen",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the GovGen network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "kusama-rpc",
    "name": "Kusama",
    "rpcs": [
      {
        "platform": "kusama-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://kusama-rpc.publicnode.com",
        "title": "RPC Gateway to Kusama",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Kusama network. Connect reliably to Web3 with ease!",
      },
    ],
  },
  {
    "id": "cataclysm-1",
    "name": "Nibiru",
    "rpcs": [
      {
        "platform": "nibiru-rpc",
        "short_name": "RPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "https://nibiru-rpc.publicnode.com:443",
        "title": "RPC Gateway to Nibiru",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Nibiru network. Connect reliably to Web3 with ease!",
      },
      {
        "platform": "nibiru-grpc",
        "short_name": "GRPC",
        "network": "Mainnet",
        "network_type": "",
        "endpoint": "nibiru-grpc.publicnode.com:443",
        "title": "RPC Gateway to Nibiru",
        "subtitle": "Fastest, free-est, and privacy first RPC endpoint for the Nibiru network. Connect reliably to Web3 with ease!",
      },
    ],
  },
]

export const chainImgs = [
  {
    "chain": "ethereum",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18Z\" fill=\"#372F45\"></path><g clip-path=\"url(#ethereum_svg__a)\"><g clip-path=\"url(#ethereum_svg__b)\"><path d=\"M18.001 30.182V23.9l-7.773-4.545 7.773 10.828Z\" fill=\"#F0CDC2\"></path><path d=\"M18.027 30.182V23.9l7.773-4.545-7.773 10.828Z\" fill=\"#C9B3F5\"></path><path d=\"M18 22.338v-8.02L10.14 17.84 18 22.338Z\" fill=\"#88AAF1\"></path><path d=\"M18.027 22.338v-8.02l7.862 3.521-7.862 4.499Z\" fill=\"#C9B3F5\"></path><path d=\"M10.139 17.84 18 5.14v9.179l-7.861 3.52Z\" fill=\"#F0CDC2\"></path><path d=\"m25.889 17.84-7.862-12.7v9.179l7.862 3.52Z\" fill=\"#B8FAF6\"></path></g></g><defs><clipPath id=\"ethereum_svg__a\"><path fill=\"#fff\" transform=\"translate(10 5)\" d=\"M0 0h16v25.75H0z\"></path></clipPath><clipPath id=\"ethereum_svg__b\"><path fill=\"#fff\" transform=\"translate(10 5)\" d=\"M0 0h16v25.322H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "bsc",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 96 96\"><path d=\"M48 96c26.51 0 48-21.49 48-48S74.51 0 48 0 0 21.49 0 48s21.49 48 48 48Z\" fill=\"#F3BA2F\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M35.606 43.51 48.36 31.083l12.759 12.436 7.42-7.233-20.18-19.67-20.172 19.663 7.42 7.233Zm-4.722 4.169-7.134-7.075-7.134 7.075 7.134 7.075 7.134-7.075Zm17.478 17.24-12.748-12.43-7.428 7.223.01.01 20.166 19.663 20.172-19.669.004-.004-7.422-7.229L48.362 64.92Zm24.251-10.162 7.134-7.075-7.133-7.075-7.135 7.075 7.134 7.075ZM55.085 48h-.003l.006.003-.003.004-6.723 6.722-6.716-6.716-.009-.01.01-.01 1.177-1.177.57-.57 4.968-4.968L55.085 48Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "polygon",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 24 24\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Z\" fill=\"#7A4ADD\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.86 4.817c.331-.2.767-.204 1.094.008 1.096.642 2.193 1.281 3.286 1.928.29.164.484.478.492.813.016.468.002.936.006 1.404-.52.307-1.042.613-1.564.918-.002-.445.002-.89-.001-1.336.008-.389-.24-.745-.573-.926-.566-.325-1.13-.655-1.698-.976a1.041 1.041 0 0 0-1.058-.005c-.595.34-1.19.681-1.782 1.028a.987.987 0 0 0-.494.88c-.005.68-.002 1.364-.002 2.045-.009.373.215.722.53.906.549.326 1.104.642 1.653.966.219.132.467.234.727.212.287-.015.526-.189.767-.328.917-.54 1.828-1.095 2.758-1.614 1.019-.57 2.014-1.182 3.022-1.77.325-.196.752-.215 1.078-.01 1.056.606 2.108 1.222 3.163 1.83.217.126.453.251.585.474.128.2.153.441.151.673-.003 1.272.003 2.544-.004 3.815-.01.396-.286.734-.626.908-1.074.616-2.144 1.237-3.218 1.85-.325.196-.75.216-1.076.016-1.075-.614-2.144-1.236-3.218-1.851-.333-.163-.628-.465-.644-.857-.026-.484-.004-.97-.01-1.455l1.563-.918c.004.464-.005.929.004 1.393.011.358.242.682.547.855.567.33 1.136.657 1.705.982.324.194.75.214 1.075.012a200.24 200.24 0 0 0 1.77-1.049.981.981 0 0 0 .503-.829c.012-.698.002-1.397.004-2.096.011-.375-.213-.731-.533-.914-.58-.337-1.16-.673-1.743-1.004-.312-.18-.715-.2-1.03-.014-1.923 1.099-3.826 2.234-5.746 3.337-.286.162-.573.373-.916.373-.234.012-.45-.09-.647-.206-1.084-.629-2.173-1.248-3.254-1.879a.996.996 0 0 1-.504-.895c-.002-1.295-.004-2.59.001-3.886a.992.992 0 0 1 .504-.876C5.622 6.1 6.74 5.459 7.859 4.817Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "avalanche",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 96 96\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M95.981 47.99c0 26.505-21.486 47.991-47.99 47.991C21.485 95.981 0 74.495 0 47.991 0 21.485 21.486 0 47.99 0c26.505 0 47.991 21.486 47.991 47.99Z\" fill=\"#E84142\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32.774 69.33h-7.986c-2.457 0-3.685 0-4.421-.477a2.967 2.967 0 0 1-1.35-2.324c-.05-.875.56-1.942 1.777-4.076L43.86 22.006c1.235-2.165 1.853-3.248 2.638-3.65a2.967 2.967 0 0 1 2.705-.003c.786.402 1.405 1.484 2.643 3.647l4.074 7.119c1.35 2.36 2.025 3.54 2.322 4.785a8.9 8.9 0 0 1 .002 4.122c-.296 1.245-.97 2.426-2.319 4.787L44.754 62.376c-1.368 2.395-2.052 3.593-2.99 4.489a8.902 8.902 0 0 1-3.61 2.095c-1.242.37-2.622.37-5.38.37ZM72.906 69.334h-12.36c-2.48 0-3.72 0-4.458-.48a2.967 2.967 0 0 1-1.345-2.34c-.044-.88.58-1.951 1.828-4.094l6.17-10.595c1.233-2.115 1.849-3.173 2.629-3.57a2.967 2.967 0 0 1 2.683-.001c.78.395 1.398 1.452 2.633 3.566l6.19 10.595c1.253 2.144 1.88 3.215 1.837 4.096a2.967 2.967 0 0 1-1.344 2.342c-.739.48-1.98.48-4.463.48Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "base",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z\" fill=\"#144DF5\"></path><path d=\"M17.98 30C24.617 30 30 24.628 30 18c0-6.627-5.382-12-12.02-12C11.68 6 6.512 10.836 6 16.991h15.889v2.018H6C6.513 25.164 11.68 30 17.98 30Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "arbitrum",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#arbitrum_svg__a)\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#213147\"></path><path d=\"M17.819 5.55h.375c.287.043.56.15.811.294 3 1.74 6.005 3.473 9.007 5.21a1.893 1.893 0 0 1 .987 1.73v10.41a1.876 1.876 0 0 1-.911 1.684c-3 1.745-6.01 3.472-9.01 5.216-.26.152-.54.274-.837.333h-.462c-.917-.219-1.656-.862-2.489-1.277.205-.482.384-.975.556-1.469.731.38 1.399.913 2.173 1.19.757-.316 1.427-.813 2.15-1.196l2.398-1.385.936-.543c.801-.463 1.604-.925 2.403-1.39.454-.278.937-.511 1.381-.808.216-.123.165-.404.183-.61-.008-3.089-.004-6.177-.002-9.265-.01-.37.042-.752-.054-1.114-.2-.236-.504-.348-.76-.51-2.795-1.609-5.584-3.23-8.377-4.84a.486.486 0 0 0-.578.011c-2.923 1.691-5.843 3.387-8.77 5.07-.122.085-.272.15-.353.279-.06.409-.024.824-.03 1.235.002 3.09 0 6.178 0 9.268.017.156-.028.367.144.454.45.316.952.552 1.42.84-.185.492-.359.988-.515 1.49-.57-.342-1.159-.658-1.726-1.007-.462-.277-.745-.77-.868-1.285V12.462c.098-.571.44-1.1.95-1.383 3.001-1.742 6.008-3.476 9.01-5.216.265-.155.552-.274.858-.313Z\" fill=\"#9DCCED\"></path><path d=\"M17.698 7.221a.486.486 0 0 1 .578-.011c2.793 1.61 5.582 3.231 8.376 4.84.257.162.561.274.76.51.097.361.045.743.055 1.114-.002 3.088-.006 6.176.002 9.264-.018.207.032.488-.183.61-.445.298-.927.531-1.381.81-1.245-3.38-2.452-6.773-3.709-10.148l-.283-.003c-.376.952-.7 1.924-1.066 2.879-.117.327-.297.681-.122 1.024.928 2.545 1.862 5.088 2.777 7.637l-.936.543c-.74-2.02-1.48-4.037-2.205-6.062a2.245 2.245 0 0 0-.285-.54c-.242.104-.303.372-.392.592-.306.865-.619 1.727-.941 2.585-.07.218-.19.453-.078.681.495 1.378 1.002 2.753 1.503 4.129-.723.383-1.394.88-2.15 1.196-.774-.277-1.442-.81-2.173-1.19 1.755-4.801 3.498-9.607 5.25-14.408.157-.428.36-.85.355-1.316-.837-.008-1.673-.032-2.507.004-.236-.013-.351.22-.419.407l-5.61 15.408-.945-.545 5.077-13.944c.137-.385.302-.759.397-1.155-.081-.24-.345-.175-.54-.19-.672.017-1.345-.022-2.015.02-.237-.013-.334.237-.411.416-1.456 3.997-2.908 7.994-4.368 11.99-.468-.289-.97-.525-1.42-.84-.173-.088-.127-.3-.145-.455.002-3.09.003-6.179 0-9.268.007-.411-.03-.826.03-1.235.082-.13.232-.194.354-.28 2.926-1.682 5.847-3.378 8.77-5.069Z\" fill=\"#213147\"></path><path d=\"M14.477 12.377c.078-.18.174-.43.412-.417.67-.041 1.343-.002 2.014-.019.195.014.46-.05.54.19-.095.396-.26.77-.397 1.155-1.691 4.647-3.385 9.295-5.077 13.943-.79-.46-1.582-.916-2.374-1.374.156-.502.33-.998.515-1.489 1.46-3.996 2.912-7.992 4.367-11.99ZM18.525 12.367c.067-.188.183-.42.419-.408.834-.035 1.67-.011 2.507-.003.005.465-.198.888-.356 1.316-1.751 4.801-3.494 9.606-5.25 14.408-.172.494-.35.986-.555 1.468-.792-.456-1.583-.916-2.375-1.373l5.61-15.408Z\" fill=\"#fff\"></path><path d=\"m21.913 14.208.283.002c1.257 3.375 2.464 6.77 3.709 10.148-.8.465-1.602.927-2.403 1.39-.915-2.549-1.849-5.092-2.777-7.637-.175-.343.005-.697.122-1.024.367-.955.69-1.927 1.066-2.879ZM19.684 20.281c.089-.22.15-.488.392-.592.12.166.215.349.285.54.724 2.025 1.465 4.043 2.204 6.062-.8.46-1.598.923-2.397 1.385-.502-1.376-1.008-2.75-1.503-4.13-.112-.227.008-.462.077-.68.323-.859.636-1.72.942-2.585Z\" fill=\"#12AAFF\"></path></g><defs><clipPath id=\"arbitrum_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "optimism",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#optimism_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#FF273F\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.21 22.855c.817.596 1.865.894 3.145.894 1.548 0 2.784-.357 3.71-1.07.924-.724 1.574-1.816 1.95-3.274.226-.895.42-1.816.581-2.763.054-.34.081-.623.081-.846 0-.746-.188-1.385-.564-1.917-.377-.543-.893-.948-1.549-1.214-.656-.277-1.398-.415-2.226-.415-3.042 0-4.93 1.464-5.66 4.392a52.465 52.465 0 0 0-.597 2.763 5.69 5.69 0 0 0-.081.862c0 1.118.403 1.98 1.21 2.588Zm4.903-1.933c-.42.351-.93.527-1.532.527-1.033 0-1.549-.49-1.549-1.47 0-.233.022-.457.065-.67a34.42 34.42 0 0 1 .58-2.62c.183-.723.484-1.26.904-1.612.43-.351.946-.527 1.548-.527 1.021 0 1.532.484 1.532 1.453 0 .234-.021.463-.064.687-.13.745-.318 1.618-.565 2.619-.183.724-.49 1.262-.92 1.613Zm4.968 2.555a.343.343 0 0 0 .274.112h2.194c.107 0 .21-.037.306-.112a.457.457 0 0 0 .178-.287l.741-3.498h2.178c1.408 0 2.516-.293 3.322-.878.817-.586 1.36-1.49 1.63-2.715.064-.287.096-.564.096-.83 0-.927-.366-1.635-1.097-2.125-.72-.49-1.677-.734-2.87-.734h-4.29a.494.494 0 0 0-.307.111.456.456 0 0 0-.178.288l-2.225 10.38a.38.38 0 0 0 .048.288Zm7.161-6.356a1.934 1.934 0 0 1-1.177.367H22.21l.613-2.858h1.935c.441 0 .753.085.936.255.183.16.274.394.274.703 0 .138-.016.298-.049.479-.107.458-.333.81-.677 1.054Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"optimism_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "fantom",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#3367F6\"></path><path d=\"M16.902 5.24c.616-.32 1.553-.32 2.17 0l6.286 3.258c.37.192.574.479.611.774h.006V25.65c-.008.323-.214.643-.617.852l-6.287 3.259c-.616.319-1.553.319-2.169 0l-6.286-3.259c-.402-.208-.595-.53-.604-.852a1.125 1.125 0 0 1 0-.08V9.378a.94.94 0 0 1 0-.053v-.053h.003c.028-.299.222-.578.601-.774l6.286-3.259Zm8.083 13.17-5.913 3.065c-.616.319-1.554.319-2.17 0l-5.9-3.059v7.201l5.9 3.043c.333.175.68.345 1.017.367l.068.002c.352.001.694-.175 1.041-.34l5.957-3.098V18.41ZM8.99 25.293c0 .627.075 1.04.222 1.33.123.241.306.425.641.65l.02.012c.073.048.154.1.252.16l.117.07.357.21-.512.832-.4-.237-.067-.04a8.845 8.845 0 0 1-.3-.19c-.956-.632-1.312-1.32-1.319-2.754v-.043h.99Zm8.503-11.274a.905.905 0 0 0-.128.053l-6.286 3.258-.019.01-.005.004.01.005.014.008 6.286 3.258c.04.02.082.038.128.054v-6.65Zm.99 0v6.65a.917.917 0 0 0 .127-.054l6.287-3.258a.624.624 0 0 0 .018-.01l.006-.003-.01-.006-.014-.008-6.287-3.258a.905.905 0 0 0-.127-.053Zm6.503-3.586-5.639 2.923 5.64 2.923v-5.846Zm-13.984.007v5.832l5.626-2.916-5.626-2.916Zm7.608-4.343c-.327-.17-.918-.17-1.245 0l-6.286 3.258a.72.72 0 0 0-.019.01l-.005.003.01.006.014.008 6.286 3.258c.327.17.918.17 1.245 0l6.287-3.258a.543.543 0 0 0 .018-.01l.006-.004-.01-.005-.014-.008-6.287-3.258Zm7.305.357.4.237.067.04c.116.07.212.13.3.19.956.632 1.312 1.32 1.319 2.753v.044h-.99c0-.627-.074-1.04-.221-1.33-.123-.241-.306-.425-.641-.65l-.02-.012a7.682 7.682 0 0 0-.252-.16l-.117-.07-.357-.21.512-.832Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "cronos",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#cronos_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#002D74\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m17.99 5.292.02-.01L29 11.637V24.35l-10.99 6.356h-.019v-.01.01L7 24.35V11.639L17.99 5.28v.01Zm-7.73 17.172v-8.94l7.75-4.47 7.73 4.47v8.94l-7.75 4.47-7.73-4.47Zm7.748 1.465 5.129-2.968-2.125-1.227-3.004 1.74-3.004-1.74v-3.462l2.985-1.74 3.005 1.74 2.143-1.246-5.13-2.967-5.147 2.967v5.935l5.148 2.968Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"cronos_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "terra-classic",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#1D3265\"></path><path d=\"M23.395 13.654c1.836.598 3.709 1.163 5.356 2.2.019.009.056.031.075.042.162 1.16.28 2.349.029 3.507-1.429-.929-2.791-1.977-3.952-3.224-.674-.725-1.207-1.582-1.508-2.525Z\" fill=\"#FF6F03\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.417 7.893c-2.497-1.071-5.402-1.19-7.973-.301-.499.235-1.076.52-1.275 1.07-.13.529.29.992.687 1.286 1.074.772 2.318 1.265 3.546 1.738 1.245.453 2.506.86 3.767 1.269.768.248 1.536.496 2.3.755l.427.139c1.698.55 3.41 1.105 4.93 2.06-.55-3.528-3.15-6.588-6.41-8.016ZM10.764 9.77c-3.36 2.774-4.609 7.653-3.188 11.727 1.198 3.617 4.417 6.49 8.178 7.257 1.994.454 4.092.258 6.018-.395 3.208-1.123 5.874-3.767 6.855-7.019-1.364.303-2.745.605-4.151.58-3.082.081-6.155-.985-8.565-2.883-2.9-2.222-4.74-5.668-5.147-9.267Z\" fill=\"#FFD83D\"></path></svg>",
  },
  {
    "chain": "kava",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.986 0h2.04c4.11.233 8.12 1.908 11.144 4.704C33.62 7.83 35.75 12.34 36 16.986v2.04c-.233 4.108-1.908 8.12-4.705 11.144-3.125 3.45-7.635 5.58-12.281 5.83h-2.04c-4.11-.233-8.122-1.91-11.146-4.707C2.378 28.167.25 23.657 0 19.011v-2.038C.256 12.33 2.385 7.822 5.836 4.7 8.862 1.904 12.876.23 16.986 0ZM9.598 7.595v20.81c1.217.003 2.437.003 3.654 0 .002-6.937.002-13.873 0-20.81a1052.63 1052.63 0 0 0-3.654 0Zm8.921 6.03c1.535-2.003 3.07-4.006 4.594-6.017 1.165-.022 2.33-.018 3.494-.013.376.002.753.004 1.13.004l-4.41 5.851-3.43 4.55 3.43 4.55 4.41 5.85-.66.003c-1.32.006-2.64.011-3.958-.008a2099.34 2099.34 0 0 0-4.566-5.976c-1.127-1.472-2.255-2.945-3.38-4.419 1.113-1.46 2.23-2.918 3.346-4.375Z\" fill=\"#FF564F\"></path><g fill=\"#fff\"><path d=\"M9.598 7.595c1.217-.002 2.437-.001 3.654 0 .002 6.937.002 13.873 0 20.81-1.217.003-2.437.003-3.654 0V7.595ZM23.113 7.608c1.542-.03 3.083-.01 4.624-.008-2.611 3.468-5.227 6.933-7.84 10.4 2.613 3.468 5.229 6.933 7.84 10.401-1.54.006-3.08.017-4.618-.005-2.64-3.472-5.3-6.928-7.945-10.395 2.642-3.468 5.306-6.92 7.94-10.393Z\"></path></g></svg>",
  },
  {
    "chain": "opbnb",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#opbnb_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#1D1D1D\"></path><path d=\"M11.246 9.149 18 5.25l6.754 3.899-2.483 1.44-4.27-2.459-4.272 2.459-2.483-1.44Zm13.508 4.916-2.483-1.44-4.27 2.458-4.272-2.458-2.483 1.44v2.88l4.271 2.459v4.916L18 25.76l2.483-1.44v-4.916l4.271-2.459v-2.88Zm0 7.797v-2.88l-2.483 1.44v2.88l2.483-1.44Zm1.763 1.018-4.27 2.458v2.88L29 24.32v-7.797l-2.483 1.44v4.917Zm-2.483-11.273 2.483 1.44v2.88L29 14.487v-2.88l-2.483-1.44-2.483 1.44ZM15.517 26.38v2.88L18 30.703l2.483-1.44v-2.88L18 27.821l-2.483-1.44Zm-4.27-4.519 2.482 1.44v-2.88l-2.483-1.44v2.88Zm4.27-10.255L18 13.047l2.483-1.44L18 10.167l-2.483 1.44Zm-6.034 1.44 2.483-1.44-2.483-1.44L7 11.607v2.88l2.483 1.44v-2.88Zm0 4.917L7 16.524v7.796l6.754 3.899v-2.88l-4.27-2.459v-4.916Z\" fill=\"#F3BA2F\"></path></g><defs><clipPath id=\"opbnb_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "injective",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#injective_svg__a)\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#41A4F8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M27.344 27.1c.171-.194.342-.39.504-.592 4.043-4.467 4.714-12.803-1.072-18.192a11.855 11.855 0 0 0-1.345-.928c2.49 2.128 3.119 3.678 3.59 5.804.805 3.747-1.513 8.802-2.84 10.587-2.536 3.427-5.982.358-3.852-2.477 1.55-2.048 4.758-7.367 3.595-10.926-.77-2.346-3.03-4.084-4.467-4.895-2.032-.52-3.856-.632-5.826-.269 2.895.836 3.662 1.437 4.566 2.144l.11.085c4.925 3.837 1.993 8.087-.242 11.326-.178.258-.351.51-.516.753-1.767 2.223-1.966 5.566.25 7.643 1.586 1.498 3.609 1.89 5.425 1.253a5.863 5.863 0 0 0 1.622-.89c.146-.104.275-.223.393-.334l.016-.02c.008-.009.018-.017.028-.024.01-.008.02-.016.028-.026.004-.005.01-.008.017-.01.006-.003.012-.006.016-.011ZM8.655 8.899c-.17.195-.342.391-.503.594-4.044 4.467-4.717 12.8 1.07 18.191.435.346.884.655 1.345.928-2.491-2.128-3.12-3.678-3.59-5.803-.805-3.748 1.513-8.803 2.84-10.588 2.535-3.427 5.982-.358 3.852 2.478-1.55 2.048-4.759 7.367-3.596 10.926.77 2.347 3.03 4.084 4.467 4.895 2.033.519 3.857.632 5.827.268-2.89-.835-3.659-1.434-4.562-2.14-.038-.03-.075-.06-.114-.089-4.923-3.837-1.991-8.087.243-11.326.178-.258.351-.509.516-.753 1.768-2.223 1.966-5.566-.249-7.643-1.587-1.497-3.61-1.89-5.426-1.252a5.835 5.835 0 0 0-1.622.888 4.016 4.016 0 0 0-.393.335l-.015.02c-.008.01-.018.017-.028.025a.156.156 0 0 0-.029.025c-.004.005-.01.008-.016.01a.044.044 0 0 0-.017.011Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"injective_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "gnosis",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#gnosis_svg__a)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.995 0c5.12 0 9.749 2.142 13.02 5.574.448.472.875.956 1.26 1.474L17.995 21.34 3.715 7.048c.397-.512.817-1.002 1.26-1.474A17.943 17.943 0 0 1 17.996 0Zm11.067 6.939c-2.942-2.96-6.852-4.584-11.067-4.584-4.21 0-8.125 1.618-11.067 4.584l11.067 11.067L29.062 6.939Zm4.335 1.727-2.902 2.902a6.582 6.582 0 0 1 1.538 4.238 6.63 6.63 0 0 1-6.622 6.622 6.626 6.626 0 0 1-4.238-1.537l-3.179 3.178-3.178-3.178a6.582 6.582 0 0 1-4.238 1.537 6.63 6.63 0 0 1-6.622-6.622c0-1.606.581-3.086 1.537-4.238l-1.485-1.486-1.411-1.41A17.966 17.966 0 0 0 0 18c0 9.939 8.056 18 18 18s18-8.056 18-18a18.046 18.046 0 0 0-2.603-9.334Zm-4.278 4.283c.61.795.973 1.785.973 2.862 0 2.58-2.096 4.681-4.675 4.67a4.63 4.63 0 0 1-2.862-.973l6.564-6.559Zm-15.68 6.572a4.679 4.679 0 0 1-7.537-3.702 4.63 4.63 0 0 1 .973-2.862l6.565 6.564Z\" fill=\"#41A0BE\"></path></g><defs><clipPath id=\"gnosis_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "cosmos",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#cosmos_svg__a)\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0Z\" fill=\"#2B2E42\"></path><path d=\"M17.966 7.615C23.7 7.615 28.35 12.265 28.35 18c0 5.735-4.65 10.384-10.384 10.384C12.23 28.384 7.58 23.735 7.58 18c0-5.736 4.65-10.385 10.385-10.385Z\" fill=\"#1A1C31\"></path><path d=\"M18.283 3.079c-.143-.132-.217-.134-.23-.134-.012 0-.086.002-.229.134-.146.135-.322.368-.51.728-.378.717-.74 1.802-1.05 3.202-.35 1.574-.627 3.498-.802 5.652.843.408 1.71.851 2.591 1.328.882-.477 1.749-.92 2.592-1.328-.174-2.154-.451-4.078-.801-5.652-.311-1.4-.672-2.485-1.05-3.202-.189-.36-.364-.593-.511-.728Zm-.967 11.314a64.93 64.93 0 0 0-1.91-.976 64.435 64.435 0 0 0-.11 2.14 71.746 71.746 0 0 1 2.02-1.164Zm-2.534-2.055c.506-5.907 1.78-10.098 3.272-10.098 1.491 0 2.765 4.191 3.27 10.097 5.372-2.515 9.64-3.508 10.386-2.217.746 1.291-2.249 4.49-7.114 7.88 4.865 3.39 7.86 6.589 7.114 7.88-.745 1.29-5.014.298-10.385-2.217-.506 5.906-1.78 10.097-3.271 10.097-1.492 0-2.766-4.191-3.272-10.098-5.37 2.516-9.64 3.509-10.385 2.218-.746-1.291 2.249-4.49 7.114-7.88-4.865-3.39-7.86-6.589-7.114-7.88.745-1.29 5.014-.298 10.385 2.218Zm-2.65 5.235c-1.78-1.228-3.309-2.43-4.498-3.52-1.058-.969-1.817-1.824-2.25-2.51-.218-.343-.332-.611-.376-.806-.042-.19-.007-.254-.001-.264.006-.01.045-.074.23-.132.19-.06.48-.094.887-.078.81.032 1.931.262 3.3.693 1.54.484 3.345 1.206 5.299 2.132a65.552 65.552 0 0 0-.146 2.906 65.826 65.826 0 0 0-2.445 1.58Zm0 .854c-1.78 1.228-3.309 2.43-4.498 3.52-1.058.969-1.817 1.824-2.25 2.51-.218.343-.332.611-.376.806-.042.19-.007.254-.001.264.006.01.045.073.23.131.19.06.48.095.887.08.81-.033 1.931-.263 3.3-.694 1.54-.484 3.345-1.207 5.299-2.132a65.567 65.567 0 0 1-.146-2.906 65.826 65.826 0 0 1-2.445-1.58Zm2.427.739a64.45 64.45 0 0 1-1.8-1.166 64.91 64.91 0 0 1 1.8-1.166 71.213 71.213 0 0 0 0 2.332Zm.713.439a69.991 69.991 0 0 1 0-3.21 70.252 70.252 0 0 1 2.781-1.605 70.84 70.84 0 0 1 2.782 1.605 70.548 70.548 0 0 1 0 3.21 70.905 70.905 0 0 1-2.782 1.605 70.57 70.57 0 0 1-2.78-1.605Zm.024.837c.026.732.063 1.447.11 2.14a64.922 64.922 0 0 0 1.91-.975 71.874 71.874 0 0 1-2.02-1.165Zm2.758 1.57c-.882.476-1.749.919-2.592 1.327.175 2.154.451 4.078.802 5.652.31 1.4.672 2.485 1.05 3.202.188.36.364.593.51.728.143.132.217.134.23.134.012 0 .086-.002.229-.134.147-.135.322-.368.511-.728.378-.717.739-1.802 1.05-3.202.35-1.574.627-3.498.801-5.652a65.626 65.626 0 0 1-2.591-1.328Zm3.33.9c1.954.926 3.76 1.648 5.299 2.132 1.369.43 2.49.66 3.3.693.406.016.696-.019.887-.078.185-.058.224-.121.23-.132.006-.01.041-.075-.001-.264-.044-.195-.158-.463-.375-.807-.434-.685-1.193-1.54-2.25-2.51-1.19-1.09-2.72-2.291-4.499-3.52a65.548 65.548 0 0 1-2.445 1.58 65.436 65.436 0 0 1-.146 2.906Zm2.591-5.339c1.78-1.228 3.309-2.43 4.498-3.52 1.058-.969 1.817-1.824 2.25-2.51.218-.343.332-.611.376-.806.042-.19.007-.254.001-.264-.006-.01-.045-.074-.23-.132-.191-.06-.48-.094-.887-.078-.81.032-1.931.262-3.3.693-1.54.484-3.345 1.206-5.299 2.132.068.934.118 1.905.146 2.906.853.525 1.67 1.054 2.445 1.58Zm-2.426-.738c.621.388 1.222.777 1.8 1.165-.578.388-1.179.777-1.8 1.165a72.334 72.334 0 0 0 0-2.33Zm-.738-1.277a64.734 64.734 0 0 0-.11-2.14c-.624.305-1.262.63-1.91.975a71.874 71.874 0 0 1 2.02 1.165Zm-.11 7.025a64.708 64.708 0 0 1-1.91-.976 71.874 71.874 0 0 0 2.02-1.165 64.714 64.714 0 0 1-.11 2.14Z\" fill=\"#6B6F8A\" stroke=\"#6B6F8A\" stroke-width=\"0.5\"></path><path d=\"M7.98 13.586a1.109 1.109 0 1 1 0 2.217 1.109 1.109 0 0 1 0-2.217ZM25.594 9.79a1.109 1.109 0 1 1 0 2.218 1.109 1.109 0 0 1 0-2.218ZM15.82 27.192a1.108 1.108 0 1 1 .001 2.217 1.108 1.108 0 0 1 0-2.217ZM17.991 16.114a1.877 1.877 0 1 1 0 3.755 1.877 1.877 0 0 1 0-3.755Z\" fill=\"#B4B6C4\"></path></g><defs><clipPath id=\"cosmos_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "dydx",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#dydx_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#252538\"></path><path d=\"M22.217 8.934 9.5 27.065h3.904L26.187 8.934h-3.97ZM13.81 8.934l3.742 5.343L15.6 17.19 9.825 8.934h3.986Z\" fill=\"#fff\"></path><path d=\"m22.596 27.067-4.149-5.91 2.163-2.833 5.89 8.743h-3.904Z\" fill=\"#7370FF\"></path></g><defs><clipPath id=\"dydx_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "mantle",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#mantle_svg__a)\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#1D1D1D\"></path><path d=\"M10.35 14.119 6.407 12.11A12.955 12.955 0 0 0 5.627 14l4.21 1.362c.137-.426.31-.844.513-1.242ZM13.7 10.579l2.184 3.762c.319-.184.66-.327 1.015-.422l-1.13-4.201c.288-.078.58-.142.874-.188l-.695-4.37c-.671.107-1.339.268-1.984.478l1.35 4.139c-.429.14-.847.314-1.25.52l-1.985-3.874c-.604.31-1.188.668-1.736 1.069l2.608 3.574c.24-.175.492-.337.75-.487ZM25.418 13.697l-3.762 2.186c.186.318.328.66.424 1.014l4.2-1.132c.078.288.142.58.188.873l4.37-.695a12.97 12.97 0 0 0-.48-1.985l-4.138 1.353a8.632 8.632 0 0 0-.52-1.25l3.873-1.988c-.31-.603-.67-1.187-1.07-1.735l-3.573 2.61c.175.24.338.491.488.749ZM23.885 6.406a13.01 13.01 0 0 0-1.888-.779l-1.36 4.21c.426.138.844.31 1.243.513l2.005-3.944ZM22.313 10.502l-2.208 3.833c.32.184.614.41.877.671l6.195-6.215a13.11 13.11 0 0 0-1.552-1.322l-2.555 3.523a8.703 8.703 0 0 0-.757-.49ZM10.505 13.682l3.832 2.21c.184-.319.41-.614.672-.877L8.796 8.819c-.48.48-.924 1.003-1.322 1.551l3.522 2.557a8.667 8.667 0 0 0-.491.756ZM19.34 9.456l.67-4.301A13.124 13.124 0 0 0 18 5h-.01v8.776H18c.37 0 .735.047 1.088.14l1.134-4.276a8.628 8.628 0 0 0-.881-.184ZM13.916 16.91 9.64 15.77c-.077.29-.138.585-.185.882l-4.3-.67a13.134 13.134 0 0 0-.156 2.016h8.776c0-.37.047-.737.141-1.09ZM25.649 21.885l3.942 2.007c.309-.606.571-1.241.78-1.888l-4.21-1.361a8.51 8.51 0 0 1-.512 1.242ZM22.3 25.42l-2.183-3.762c-.319.185-.66.327-1.015.423l1.13 4.201a8.45 8.45 0 0 1-.874.188l.694 4.37c.672-.107 1.34-.268 1.984-.479l-1.35-4.139c.43-.14.848-.314 1.25-.52l1.986 3.875a13.04 13.04 0 0 0 1.736-1.07l-2.609-3.573c-.24.175-.49.337-.748.487ZM10.582 22.302l3.762-2.186a4.2 4.2 0 0 1-.423-1.014L9.72 20.234a8.535 8.535 0 0 1-.188-.874l-4.37.696c.107.672.268 1.34.48 1.985l4.137-1.353c.141.43.315.848.521 1.25l-3.873 1.988c.31.603.67 1.187 1.07 1.735l3.573-2.61a8.567 8.567 0 0 1-.488-.749ZM12.114 29.594a13 13 0 0 0 1.888.78l1.36-4.211a8.565 8.565 0 0 1-1.243-.513l-2.005 3.944ZM13.685 25.499l2.21-3.833a4.248 4.248 0 0 1-.878-.672L8.822 27.21c.48.479 1.003.924 1.552 1.322l2.555-3.524c.243.177.496.34.756.49ZM25.496 22.319l-3.832-2.212a4.26 4.26 0 0 1-.673.878l6.213 6.197c.48-.48.924-1.002 1.323-1.55l-3.523-2.557c.177-.243.342-.496.492-.756ZM16.912 22.084l-1.135 4.276c.29.077.585.138.882.185l-.668 4.301c.66.103 1.337.155 2.01.155h.01v-8.776H18c-.37 0-.737-.048-1.089-.141ZM22.224 18c0 .37-.047.737-.141 1.09l4.276 1.138c.077-.29.138-.585.185-.882l4.3.67A13.14 13.14 0 0 0 31 18h-8.776Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"mantle_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "haqq",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z\" fill=\"#157C83\"></path><path d=\"m18 6 3.674 3.13 4.811.385.384 4.811L30 18l-3.13 3.674-.385 4.811-4.811.384L18 30l-3.674-3.13-4.811-.385-.384-4.811L6 18l3.13-3.674.385-4.811 4.811-.384L18 6Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "pulsechain",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#pulsechain_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#0080FF\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m6.804 18.608 5.072 8.785c.217.376.618.607 1.052.607h10.144c.434 0 .835-.231 1.053-.607l5.072-8.785h-6.335a.608.608 0 0 1-.506-.271l-.487-.73-2.07 7.245a.608.608 0 0 1-1.184-.07l-1.67-10.265-1.7 6.374a.608.608 0 0 1-1.12.139l-1.345-2.422H6.804Zm0-1.216h6.334c.22 0 .424.12.53.313l.79 1.42 2.043-7.663a.608.608 0 0 1 1.187.059l1.69 10.382 1.684-5.893a.608.608 0 0 1 1.09-.17l1.035 1.552h6.01l-5.072-8.784A1.216 1.216 0 0 0 23.072 8H12.928c-.434 0-.835.232-1.052.608l-5.072 8.784Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"pulsechain_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "evmos",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#E9575B\"></path><path d=\"M16.494 9.17a8.737 8.737 0 0 1 5.855.876c.278.13.272.589-.019.701-.148.097-.32.005-.47-.037a6.867 6.867 0 0 0-4.378-.112c-1.437.438-2.73 1.353-3.591 2.583a6.798 6.798 0 0 0-1.264 3.979c3.844-1.708 7.798-3.184 11.86-4.292 1.836-.483 3.695-.93 5.595-1.063.616-.017 1.278-.06 1.844.225.282.134.349.515.193.769-.313.6-.867 1.02-1.388 1.431-1.087.808-2.26 1.493-3.453 2.131-.156.113-.413.09-.475-.114-.155-.59-.252-1.204-.516-1.76-.096-.21-.353-.09-.519-.06-4.417 1.15-8.716 2.734-12.86 4.634a6.913 6.913 0 0 0 2.732 3.711 6.948 6.948 0 0 0 4.791 1.119c1.887-.249 3.655-1.309 4.732-2.875.224-.294.367-.638.58-.937.242-.265.753-.003.663.353-.537 1.635-1.629 3.07-3.006 4.101-1.78 1.31-4.081 1.953-6.281 1.603-1.554-.221-2.993-.886-4.39-1.566-.988-.495-1.994-1.025-3.108-1.162-1.436-.206-2.878.07-4.318.033-.375-.027-.853-.086-1.047-.454-.201-.468.195-.89.502-1.197 1.098-.992 2.396-1.78 3.317-2.958.623-.784.97-1.733 1.341-2.649.576-1.46 1.205-2.932 2.222-4.15 1.21-1.492 2.975-2.491 4.856-2.863Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "sei",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#sei_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#fff\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.962 33.084a15 15 0 0 0 11.213-5.018 3.566 3.566 0 0 0-4.575-.08l-.26.21a6.02 6.02 0 0 1-8.272-.677 3.214 3.214 0 0 0-4.489-.3l-3.004 2.576a14.974 14.974 0 0 0 9.387 3.288Zm4.876-7.282a6.374 6.374 0 0 1 8.008.003A14.968 14.968 0 0 0 33 18.045c0-3.154-.971-6.081-2.63-8.5a3.56 3.56 0 0 0-3.11.82l-.252.221a6.02 6.02 0 0 1-8.293-.294 3.213 3.213 0 0 0-4.498-.092l-3.496 3.288-1.923-2.044 3.496-3.288a6.02 6.02 0 0 1 8.426.173 3.214 3.214 0 0 0 4.427.157l.25-.222a6.346 6.346 0 0 1 2.622-1.399 14.982 14.982 0 0 0-10.057-3.857c-7.633 0-13.939 5.688-14.908 13.057a6.16 6.16 0 0 1 7.07 1.252 3.352 3.352 0 0 0 4.46.3l1.955-1.528a6.505 6.505 0 0 1 8.278.222l3.805 3.315-1.843 2.116-3.805-3.315a3.7 3.7 0 0 0-4.707-.126l-1.955 1.526a6.158 6.158 0 0 1-8.197-.55 3.352 3.352 0 0 0-4.691-.102L3 19.57c.316 3.141 1.6 5.997 3.547 8.265l3.205-2.747a6.02 6.02 0 0 1 8.409.562 3.214 3.214 0 0 0 4.416.36l.26-.21Z\" fill=\"#9E1F19\"></path></g><defs><clipPath id=\"sei_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "sui",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#sui_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#5B9DF8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.003 15.687a7.617 7.617 0 0 1 1.665 4.766 7.617 7.617 0 0 1-1.713 4.824l-.092.113-.024-.144a6.784 6.784 0 0 0-.074-.371c-.536-2.355-2.282-4.375-5.157-6.01-1.94-1.1-3.052-2.427-3.343-3.933-.189-.974-.049-1.953.222-2.79.27-.839.673-1.54 1.015-1.963l1.119-1.368a.49.49 0 0 1 .759 0l5.623 6.876Zm1.768-1.366-7.494-9.164a.358.358 0 0 0-.554 0l-7.494 9.163-.025.031A9.931 9.931 0 0 0 8 20.605c0 5.513 4.477 9.983 10 9.983s10-4.47 10-9.983a9.931 9.931 0 0 0-2.204-6.254l-.025-.03Zm-13.75 1.336.671-.82.02.152c.017.12.036.24.06.36.433 2.276 1.982 4.174 4.573 5.644 2.252 1.281 3.563 2.755 3.94 4.371.158.675.186 1.338.118 1.918l-.005.036-.032.016A7.648 7.648 0 0 1 18 28.11c-4.235 0-7.669-3.427-7.669-7.656 0-1.815.633-3.483 1.69-4.796Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"sui_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "celestia",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#celestia_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#7A2BF9\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M29.919 18.354c-.003.081-.113.102-.144.028a7.176 7.176 0 0 0-.042-.096.178.178 0 0 1 .02-.179l.044-.057c.052-.068.127-.058.127.017 0 .1-.002.186-.005.287Zm-.578-1.576a.242.242 0 0 1-.415.014l-.046-.072a14.121 14.121 0 0 0-1.222-1.603.199.199 0 0 1 .15-.33h.003c1.069 0 1.629.265 1.8.587.142.27.099.74-.27 1.404Zm-.238 5.587c-.058.146-.118.29-.18.434l-.03.06c-.393.756-1.053 1.352-1.934 1.767a.255.255 0 0 1-.356-.299 22.7 22.7 0 0 0 .658-3.375.9.9 0 0 1 .306-.573c.362-.313.7-.626 1.012-.937l.004-.004a.287.287 0 0 1 .477.12c.308 1.023.325 1.976.043 2.807Zm-2.397 3.783a12.018 12.018 0 0 1-.773.755c-.107.095-.27-.024-.209-.155l.052-.112a13.6 13.6 0 0 0 .207-.484.133.133 0 0 1 .09-.078c.17-.043.334-.09.495-.142.13-.042.232.116.138.216Zm-1.76-.946c-.356.051-.73.085-1.122.099a13.965 13.965 0 0 1-3.003-.24.135.135 0 0 1-.036-.253 36.738 36.738 0 0 0 5.045-3.056.135.135 0 0 1 .212.131 19.392 19.392 0 0 1-.742 3.022.442.442 0 0 1-.354.297Zm-.367 1.44c-.851 1.674-1.9 2.614-2.916 2.595-1.104-.02-2.206-1.17-3.021-3.155l-.001-.002a.25.25 0 0 1 .133-.325l.025-.011a.254.254 0 0 1 .17-.012c1.526.428 3.03.652 4.438.652a13.218 13.218 0 0 0 .976-.038.204.204 0 0 1 .196.296Zm-5.04 3.184c-.507.065-1.02.098-1.54.098-2.317 0-4.534-.657-6.437-1.882-.13-.085-.075-.288.08-.295a12.863 12.863 0 0 0 1.678-.218c1.222-.235 2.581-.638 4.004-1.181a.252.252 0 0 1 .322.14v.003c.552 1.342 1.23 2.356 1.993 3.002a.19.19 0 0 1-.1.333Zm-6.896-8.355a31.05 31.05 0 0 1 3.632-2.518c.03 1.728.219 3.386.554 4.884-.501-.213-1-.449-1.495-.706a21.176 21.176 0 0 1-2.691-1.66Zm-3.268 4.628c-.25-.473.073-1.568 1.72-3.233v-.001a.41.41 0 0 0-.036-.61 20.742 20.742 0 0 1-.197-.156.411.411 0 0 0-.55.029 5.963 5.963 0 0 0-.064.064c-.823.845-1.398 1.626-1.721 2.33a.28.28 0 0 1-.488.037A11.839 11.839 0 0 1 6.076 18c0-.845.088-1.678.259-2.487.026-.123.198-.13.235-.01.247.816.65 1.66 1.206 2.515.749 1.15 1.737 2.256 2.907 3.27.4.346.822.681 1.262 1.004a22.18 22.18 0 0 0 2.892 1.795c.457.237.903.464 1.359.67.253.113.542.122.801.02.215-.084.432-.171.65-.262a.52.52 0 0 0 .302-.606 7.189 7.189 0 0 1-.017-.07c-.36-1.512-.559-3.213-.582-4.995l-.001-.063c-.001-.098 0-.196-.003-.293l.001-.115v-.037a26.767 26.767 0 0 1 .036-1.244c.11-2.15.475-4.17 1.055-5.87a.3.3 0 0 0-.187-.381 18.616 18.616 0 0 0-.46-.15.299.299 0 0 0-.372.188c-.629 1.845-1.017 4.035-1.12 6.352a.872.872 0 0 1-.426.711 32.863 32.863 0 0 0-3.721 2.545.602.602 0 0 1-.77-.016c-1.092-.946-2.01-1.974-2.704-3.04-1.365-2.095-1.689-4.069-.913-5.556l.006-.01c.099-.165.202-.327.309-.487.891-1.18 2.55-1.863 4.751-1.94.14-.006.28-.008.421-.008 1.35 0 2.798.223 4.272.648l.097.028.075.022c.34.101.681.214 1.023.337l.024.009a20.04 20.04 0 0 1 .35.13l.081.031c.72.279 1.438.603 2.148.972a20.572 20.572 0 0 1 3.727 2.469c-2.09.478-4.517 1.401-6.959 2.646a.356.356 0 0 0-.194.297c-.008.151-.02.456-.027.697a.198.198 0 0 0 .29.182h.001c2.417-1.27 4.83-2.219 6.901-2.72a.774.774 0 0 0 .584-.86 21.293 21.293 0 0 0-.129-.814 1.354 1.354 0 0 0-.513-.84c-.97-.74-2.04-1.417-3.185-2.012-.771-.4-1.554-.752-2.338-1.052a.295.295 0 0 1-.152-.419c.808-1.445 1.769-2.255 2.705-2.255h.03c1.104.02 2.205 1.17 3.02 3.156.414 1.005.734 2.164.952 3.424l-.003-.004c.093.538.168 1.094.224 1.664l-.015.008.02.02a26.653 26.653 0 0 1 .012 4.865c-1.477 1.195-3.304 2.384-5.312 3.448a38.465 38.465 0 0 1-2.004.989l-.15.069h-.001c-.542.244-1.078.47-1.605.678l-.09.034a22.79 22.79 0 0 1-.375.144l-.073.027c-.106.04-.212.078-.318.116l-.04.015c-1.13.402-2.207.706-3.188.895-2.371.456-3.488.106-3.742-.374Zm1.703-17.81A11.834 11.834 0 0 1 18 6.075c.664 0 1.32.054 1.963.16a.2.2 0 0 1 .092.356c-.622.488-1.2 1.21-1.713 2.148a.557.557 0 0 1-.64.27c-1.697-.478-3.366-.703-4.909-.649a11.05 11.05 0 0 0-1.613.171c-.143.026-.22-.16-.102-.244Zm16.368 8.69a.138.138 0 0 1 .251-.084 11.785 11.785 0 0 1 .615.96.3.3 0 0 1-.039.35 13.946 13.946 0 0 1-.637.655.12.12 0 0 1-.202-.09 27.94 27.94 0 0 0 .012-1.791Zm-1.237-7.627a11.9 11.9 0 0 1 2.848 4.17.2.2 0 0 1-.221.274 5.992 5.992 0 0 0-1.155-.082.601.601 0 0 1-.604-.493c-.232-1.3-.568-2.501-.998-3.55l-.074-.176c-.055-.128.104-.239.204-.143Zm4.51 5.944a12.91 12.91 0 0 0-3.527-6.489A12.915 12.915 0 0 0 18 5a12.915 12.915 0 0 0-9.192 3.807 13.138 13.138 0 0 0-1.592 1.927 4.643 4.643 0 0 0-.37.58A12.92 12.92 0 0 0 5 18c0 3.472 1.352 6.737 3.808 9.192A12.915 12.915 0 0 0 18 31c3.472 0 6.737-1.352 9.192-3.808a12.99 12.99 0 0 0 2.713-3.954c.078-.161.147-.326.206-.495a13.125 13.125 0 0 0 .616-7.414l-.008-.033Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"celestia_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "moonbeam",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z\" fill=\"#171D44\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.32 15.36a8.36 8.36 0 0 0-16.72 0h16.72Z\" fill=\"#53CBC8\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.08 17.34a.66.66 0 1 1 1.32 0 .66.66 0 0 1-1.32 0Zm2.2 0a.66.66 0 0 1 .66-.66h18.04a.66.66 0 0 1 0 1.32H9.94a.66.66 0 0 1-.66-.66Zm-4.4 6.6a.66.66 0 1 1 1.32 0 .66.66 0 0 1-1.32 0Zm2.86-.66a.66.66 0 0 0 0 1.32h5.28a.66.66 0 0 0 0-1.32H7.74Zm7.48 0a.66.66 0 0 0 0 1.32h13.64a.66.66 0 0 0 0-1.32H15.22Zm-7.48-2.2a.66.66 0 1 0 0 1.32.66.66 0 0 0 0-1.32Zm2.2 0a.66.66 0 0 0 0 1.32h15.4a.66.66 0 0 0 0-1.32H9.94ZM4 19.54a.66.66 0 1 1 1.32 0 .66.66 0 0 1-1.32 0Zm2.2 0a.66.66 0 0 1 .66-.66h12.32a.66.66 0 0 1 0 1.32H6.86a.66.66 0 0 1-.66-.66Zm5.06 8.14a.66.66 0 1 0 0 1.32.66.66 0 0 0 0-1.32Zm2.2 0a.66.66 0 1 0 0 1.32h7.48a.66.66 0 0 0 0-1.32h-7.48Zm2.42-1.54a.66.66 0 1 1 1.32 0 .66.66 0 0 1-1.32 0Zm2.2 0a.66.66 0 0 1 .66-.66h7.04a.66.66 0 0 1 0 1.32h-7.04a.66.66 0 0 1-.66-.66Z\" fill=\"#E1147B\"></path></svg>",
  },
  {
    "chain": "kujira",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#E53935\"></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 5c7.18 0 13 5.82 13 13s-5.82 13-13 13S5 25.18 5 18 10.82 5 18 5Zm0 1.444C11.618 6.444 6.444 11.618 6.444 18c0 6.382 5.174 11.555 11.556 11.555 6.382 0 11.555-5.173 11.555-11.555S24.382 6.444 18 6.444Zm3.606 3.69h-.008l-.7.122-.477.083c.226.566.425 1.143.6 1.726h-3.725v1.112h8.415v-1.111h-3.52c-.173-.651-.361-1.298-.585-1.933Zm-11.473 4.103c1.15-1.11 1.938-2.55 2.405-4.07l.366.114.733.229c-.135.35-.278.697-.43 1.042h2.835v.707c0 .061.001.124-.03.18a13.74 13.74 0 0 1-1.052 1.9h1.734v7.097h-5.65v-6.617c-.212.216-.428.428-.652.631-.059-.269-.116-.539-.173-.808l-.086-.405Zm2.594-1.71c-.373.633-.792 1.24-1.254 1.812h2.301c.417-.575.772-1.192 1.117-1.812h-2.164Zm-.618 4.856V15.35h1.27v2.035h-1.27Zm2.267-2.034v2.034c.418.002.835.001 1.254 0V15.35h-1.254Zm-2.268 3.704v-.678h1.27v2.034h-1.27v-1.356Zm2.268-.678v2.034H15.629v-2.034h-1.253Zm10.51-3.66h-6.681v4.857h2.747v4.554c-.002.182-.018.382-.142.526a.461.461 0 0 1-.36.15c-.355.007-.707-.03-1.06-.065l-.172-.018.12.573.12.573h1.507c.305-.023.625-.111.841-.34.272-.28.346-.69.348-1.066V19.572h2.731v-4.856Zm-5.514 3.78V15.81h4.346v2.685h-4.346Zm4.519 2.139-.91.547c.729 1.261 1.42 2.55 1.975 3.898l.908-.63.002-.002c-.563-1.318-1.25-2.579-1.975-3.813Zm-5.17.068.298.142.002.001.001.001.695.334c-.502 1.46-1.127 2.885-1.957 4.19l-.25-.18h-.002v-.002h-.001l-.675-.485c.794-1.249 1.403-2.607 1.89-4.001Zm-2.79 1.289h-.001l-.317.095c.277.694.518 1.401.722 2.12l.608-.148.233-.057c-.216-.73-.45-1.456-.755-2.155l-.488.145h-.001Zm-1.952.13c.287-.034.573-.069.86-.102.346.99.477 2.038.566 3.078l-.892.102c-.078-1.038-.176-2.092-.534-3.077Zm-2.987-.035c-.08 1.12-.294 2.235-.704 3.283l.706.217.239.074c.393-1.112.592-2.283.687-3.455l-.928-.119Zm1.924.103.412-.051c.157 1.064.21 2.14.24 3.215-.297.033-.595.067-.892.102l-.001-.05c-.03-1.056-.06-2.114-.17-3.165l.411-.051Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "juno",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"17.25\" fill=\"#000\" stroke=\"#fff\" stroke-width=\"1.5\"></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.803 8.837c0-.462-.35-.837-.782-.837h-.001c-.431 0-.781.375-.781.837v3.825l-2.88-3.077a.745.745 0 0 0-1.105.001h-.001a.88.88 0 0 0 .002 1.184l2.853 3.05-4.326-.004c-.432 0-.782.374-.782.836v.001c0 .462.349.837.78.837l4.363.004-2.878 3.094a.88.88 0 0 0 .002 1.183v.001c.306.326.8.325 1.105-.002l2.867-3.08v8.075h-1.594c-.431-.001-.781.373-.782.835v.001c0 .462.35.837.78.838l1.596.001v1.723c0 .462.35.837.781.837.433 0 .783-.375.783-.837v-1.721h1.526c.432.001.782-.373.783-.835v-.001c0-.462-.35-.837-.781-.838l-1.528-.001v-8.068l2.863 3.06c.305.326.8.326 1.105-.001a.88.88 0 0 0 0-1.185l-2.879-3.075 4.326.003c.431 0 .782-.374.782-.835v-.002c0-.462-.35-.837-.78-.837l-4.314-.004 2.854-3.067a.88.88 0 0 0-.002-1.184.745.745 0 0 0-1.106.002l-2.85 3.062V8.837Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "fetch",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#2747A5\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.825 10.825H8V8h2.825v2.825Zm5.922 0h-2.824V8h2.824v2.825Zm5.923 0h-2.825V8h2.825v2.825Zm-11.845 5.922H8v-2.824h2.825v2.824Zm5.922 0h-2.824v-2.824h2.824v2.824Zm-5.922 5.923H8v-2.825h2.825v2.825ZM27.18 10.232a.822.822 0 0 1-.82-.82c0-.45.369-.82.82-.82.451 0 .82.37.82.82 0 .451-.369.82-.82.82Zm0 5.923a.822.822 0 0 1-.82-.82c0-.451.369-.82.82-.82.451 0 .82.369.82.82 0 .45-.369.82-.82.82Zm0 5.922a.822.822 0 0 1-.82-.82c0-.45.369-.82.82-.82.451 0 .82.37.82.82 0 .451-.369.82-.82.82Zm0 5.923a.822.822 0 0 1-.82-.82c0-.451.369-.82.82-.82.451 0 .82.369.82.82 0 .451-.369.82-.82.82Zm-5.923-11.845a.822.822 0 0 1-.82-.82c0-.451.37-.82.82-.82.451 0 .82.369.82.82 0 .45-.369.82-.82.82Zm0 5.922a.822.822 0 0 1-.82-.82c0-.45.37-.82.82-.82.451 0 .82.37.82.82 0 .451-.369.82-.82.82Zm0 5.923a.822.822 0 0 1-.82-.82c0-.451.37-.82.82-.82.451 0 .82.369.82.82 0 .451-.369.82-.82.82Zm-5.922-5.923a.822.822 0 0 1-.82-.82c0-.45.369-.82.82-.82.45 0 .82.37.82.82 0 .451-.37.82-.82.82Zm0 5.923a.822.822 0 0 1-.82-.82c0-.451.369-.82.82-.82.45 0 .82.369.82.82 0 .451-.37.82-.82.82Zm-5.923 0a.822.822 0 0 1-.82-.82c0-.451.37-.82.82-.82.451 0 .82.369.82.82 0 .451-.369.82-.82.82Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "neutron",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z\" fill=\"#1D1D1D\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M28 8H9.417l5.29 6.237a5 5 0 0 1 7.084 7.023L28 26.603V8Zm-2.448 20-4.917-5.75a5 5 0 0 1-6.898-6.864L8 10.39V28h17.552Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "tron",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M16.986 0h2.04c4.11.233 8.12 1.908 11.144 4.704C33.62 7.83 35.75 12.34 36 16.986v2.04c-.233 4.108-1.908 8.12-4.705 11.144-3.125 3.45-7.635 5.58-12.281 5.83h-2.04c-4.11-.233-8.122-1.91-11.146-4.707C2.378 28.167.25 23.657 0 19.011v-2.038C.256 12.33 2.385 7.822 5.836 4.7 8.862 1.904 12.876.23 16.986 0Z\" fill=\"#D82B31\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.26 10.474 7 7l9.61 25L30 15.134l-4.74-4.66Zm-.293 1.531 2.793 2.745-7.64 1.43 4.847-4.175ZM10.408 8.989l8.053 6.905 5.109-4.4-13.162-2.505Zm7.48 8.126-1.313 11.223-7.08-18.42 8.392 7.197Zm9.674-.988-8.46 1.584L17.86 28.35l9.703-12.223Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "akash",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#ED3524\"></circle><g fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#fff\"><path d=\"m13.815 7 12.158 21L30 20.974 21.868 7h-8.053Z\"></path><path opacity=\"0.3\" d=\"M13.815 21.368 18 28h8.368l-4.184-6.632h-8.369Z\"></path><path d=\"M10.184 13.632 6 20.816 10.184 28l8.448-14.368h-8.448Z\"></path></g></svg>",
  },
  {
    "chain": "dymension",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M16.986 0h2.04c4.11.233 8.12 1.908 11.144 4.704C33.62 7.83 35.75 12.34 36 16.986v2.04c-.233 4.108-1.908 8.12-4.705 11.144-3.125 3.45-7.635 5.58-12.281 5.83h-2.04c-4.11-.233-8.122-1.91-11.146-4.707C2.378 28.167.25 23.657 0 19.011v-2.038C.256 12.33 2.385 7.822 5.836 4.7 8.862 1.904 12.876.23 16.986 0Z\" fill=\"#332D2C\"></path><path d=\"M6.32 21.179a4.386 4.386 0 0 1-1.174-2.023 4.634 4.634 0 0 1 0-2.307c.2-.774.588-1.45 1.167-2.03a4.35 4.35 0 0 1 2.036-1.174 4.631 4.631 0 0 1 2.307 0 4.33 4.33 0 0 1 2.03 1.167l1.445 1.446 2.14-2.14-1.445-1.446a4.386 4.386 0 0 1-1.174-2.023 4.66 4.66 0 0 1-.007-2.3 4.35 4.35 0 0 1 1.174-2.037 4.33 4.33 0 0 1 2.03-1.168 4.551 4.551 0 0 1 2.3.007 4.331 4.331 0 0 1 2.028 1.168c.584.584.973 1.26 1.168 2.03.2.764.201 1.53.007 2.3a4.28 4.28 0 0 1-1.16 2.037l-1.44 1.438 2.134 2.134 1.439-1.439a4.385 4.385 0 0 1 2.022-1.174 4.552 4.552 0 0 1 2.3.007 4.35 4.35 0 0 1 2.036 1.174c.584.584.973 1.26 1.168 2.03.199.764.199 1.529 0 2.293a4.333 4.333 0 0 1-1.168 2.03 4.35 4.35 0 0 1-2.036 1.175 4.658 4.658 0 0 1-2.3-.007 4.333 4.333 0 0 1-2.015-1.168l-1.439-1.439-2.14 2.141 1.438 1.439c.584.584.97 1.258 1.16 2.022.195.77.195 1.539 0 2.308a4.351 4.351 0 0 1-1.174 2.036c-.579.58-1.255.969-2.029 1.168a4.629 4.629 0 0 1-2.307 0 4.333 4.333 0 0 1-2.015-1.168 4.405 4.405 0 0 1-1.181-2.03 4.633 4.633 0 0 1 0-2.307 4.42 4.42 0 0 1 1.174-2.022l1.452-1.453-2.133-2.134-1.452 1.453c-.58.58-1.258.966-2.036 1.16a4.63 4.63 0 0 1-2.307 0A4.385 4.385 0 0 1 6.32 21.18Zm1.738-1.738c.264.265.57.44.917.529.352.092.702.095 1.05.007a1.96 1.96 0 0 0 .916-.529l1.453-1.452-1.446-1.446a1.907 1.907 0 0 0-.924-.521 2.09 2.09 0 0 0-1.042 0 1.977 1.977 0 0 0-.924.535 2.016 2.016 0 0 0-.535.91 2.091 2.091 0 0 0 0 1.043c.092.352.27.66.535.924Zm8.505-8.507 1.446 1.446 1.438-1.44c.269-.268.445-.574.528-.916a2.066 2.066 0 0 0-.007-1.05 1.96 1.96 0 0 0-.528-.918 1.96 1.96 0 0 0-.917-.528 2.09 2.09 0 0 0-1.042 0c-.343.084-.649.26-.918.528a2.07 2.07 0 0 0-.542.918 2.094 2.094 0 0 0 0 1.043c.098.347.278.653.542.917Zm6.66 7.069 1.439 1.438c.264.265.568.443.91.536.348.088 1.1.085 1.443-.007.347-.088.655-.267.924-.535.269-.27.445-.575.528-.918.093-.343.095-.688.007-1.036a1.96 1.96 0 0 0-.528-.917 1.977 1.977 0 0 0-.924-.535c-.348-.088-1.102-.088-1.45 0a1.98 1.98 0 0 0-.91.535l-1.438 1.439Zm-6.66 9.946a2.011 2.011 0 0 0 1.953.521 1.96 1.96 0 0 0 .917-.528c.269-.269.447-.577.535-.925.093-.343.095-.688.007-1.035a1.908 1.908 0 0 0-.52-.925l-1.44-1.438-1.452 1.452a2.016 2.016 0 0 0-.535.91 2.092 2.092 0 0 0 0 1.043c.088.348.267.656.535.925Zm-.688-9.946 2.134 2.133 2.14-2.14-2.133-2.134-2.14 2.14Z\" fill=\"#F1E1D4\"></path></svg>",
  },
  {
    "chain": "chiliz",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#chiliz_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#FF1256\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m16.622 8.141-4 2.469a.17.17 0 0 1-.232-.055l-.235-.38a1.034 1.034 0 0 1 .336-1.426l1.559-.955a.483.483 0 0 0 .086-.755L12.83 5.835a1.037 1.037 0 0 1-.005-1.468l.316-.319a.17.17 0 0 1 .237 0l3.34 3.23c.255.252.255.664-.097.863Zm-1.182 11.72a4.446 4.446 0 0 1 1.041 3.991l.003-.002s-.192 1.873-1.289 6.217c-.306 1.209.875 2.275 2.04 1.832 7.937-3.015 7.93-11.073 7.93-11.073.234-5.19-5.027-10.214-6.538-11.607a.7.7 0 0 0-.848-.075l-4.133 2.642a3.464 3.464 0 0 0-.733 5.21l2.527 2.865Zm-.824-6.576c1.044-.664 2.268-1.44 2.9-1.84v.003a.501.501 0 0 1 .61.058c8.138 7.653 4.237 13.427 1.454 15.828-.656.566-1.65-.024-1.458-.866l.443-1.943a6.851 6.851 0 0 0-1.607-6.156l-2.641-3.053a1.355 1.355 0 0 1 .299-2.031Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"chiliz_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "stride",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#E91179\"></path><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#E91179\"></path><path d=\"M25.07 22.623a2.95 2.95 0 0 1-2.95-2.95v-4.417h3.805v-2.57H22.12V8.439l-2.915 1.556v2.693h-5.529c-3.854 0-4.867 4.644-1.902 6.374l3.014 2.026c.667.494.395 1.531-.543 1.531h-4.101v2.594h4.1c3.88 0 4.867-4.644 1.903-6.374l-2.99-2.026c-.666-.494-.42-1.556.52-1.556h5.528v4.452c0 3.36 2.323 5.507 5.83 5.507h.89v-2.592h-.855Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "irisnet",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#iris_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#4768B4\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.486 10.32c2.2-3.037 5.538-4.961 9.248-5.32l-.606 1.394a11.57 11.57 0 0 0-6.799 3.715l-1.843.21Zm5.407 13.522-5.965.67 3.503-8.08-3.586-4.888 8.718-.993 2.368-5.447 5.19 7.054 5.964-.671-3.486 8.041 3.559 4.855-8.673.988-2.405 5.524-5.187-7.053Zm2.478-.536a4.261 4.261 0 0 1-.725.275l-.23.063 3.363 4.57 1.193-2.745-.216-.029a4.297 4.297 0 0 1-2.933-1.734l-.335-.463-.117.063Zm1.542-.391L14.2 19.163l3.505-.44 3.51 4.647 2.017-4.558.167.138c.18.15.34.322.48.512l2.82 3.846-7.078.805a2.95 2.95 0 0 1-2.71-1.199Zm-2.595-8.321a2.947 2.947 0 0 0-2.387 1.757l-2.842 6.56 4.722-.53c.234-.026.462-.081.683-.162l.203-.075-2.922-4.035 5.761-.73 1.37-3.274-4.588.489Zm6.593 6.136-2.135-2.826 2.252-5.38-4.937.523.036-.213c.042-.234.11-.46.203-.676l1.903-4.373 4.23 5.756c.63.853.752 1.984.322 2.953l-.572 1.295-1.302 2.94Zm3.052-7.308.084.2a4.344 4.344 0 0 1-.032 3.422l-.231.52.112.076c.213.143.413.309.598.494l.169.166 2.26-5.213-2.96.335Zm-12.859 1.653-1.799-2.454 5.655-.645-.065.234a4.229 4.229 0 0 0-.143.843l-.01.137-.565.06a4.31 4.31 0 0 0-2.94 1.654l-.133.171ZM16.743 31c-3.744-.361-7.109-2.309-9.31-5.395l1.507-.169c.25.307.515.6.788.876a11.61 11.61 0 0 0 5.925 3.209l1.09 1.48Zm9.53-4.686a11.57 11.57 0 0 1-6.39 3.291L19.277 31a12.907 12.907 0 0 0 9.297-5.4l-1.828.208c-.158.177-.317.346-.473.505Zm2.673-4.145c.5-1.329.754-2.73.754-4.168 0-1.269-.2-2.517-.592-3.708l.733-1.69A12.98 12.98 0 0 1 31 18c0 1.882-.39 3.694-1.158 5.392l-.897-1.224ZM5.001 18c0 1.89.393 3.707 1.165 5.41l.73-1.69a11.83 11.83 0 0 1-.595-3.72c0-1.456.26-2.873.772-4.215l-.894-1.222A12.954 12.954 0 0 0 5 18.001Zm21.273-8.313c.275.275.54.57.79.876l1.506-.17c-2.2-3.083-5.56-5.03-9.3-5.394l1.089 1.482a11.604 11.604 0 0 1 5.915 3.206Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"iris_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "moonriver",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z\" fill=\"#171D44\"></path><path d=\"M11.765 8.18C13.437 6.775 15.61 6.01 17.79 6c1.716.02 3.437.457 4.91 1.351 2.265 1.34 3.9 3.67 4.44 6.241.205 1.252.238 2.544-.008 3.79-1.608 1.356-3.907 1.72-5.909 1.178-1.27-.282-2.257-1.179-3.32-1.869-2.083-1.555-5.023-1.772-7.369-.707-.745.336-1.373.87-2.059 1.305-.081-.805-.239-1.615-.133-2.425a9.479 9.479 0 0 1 3.424-6.684Z\" fill=\"#F2B705\"></path><path d=\"M12.526 16.707c1.356-.234 2.756-.041 4.053.39 1.714.627 2.945 2.13 4.692 2.686 1.682.57 3.599.323 5.1-.617.334-.203.637-.458.992-.625.364-.024.697.345.628.704-.166.339-.521.516-.813.73-1.778 1.28-4.156 1.489-6.225.9-1.954-.576-3.282-2.349-5.248-2.893-.868-.175-1.763-.37-2.65-.219-.701.093-1.413.202-2.055.516-.787.343-1.427.933-2.171 1.349-.422.302-1.06-.297-.744-.73.322-.38.79-.597 1.182-.897a7.256 7.256 0 0 1 3.259-1.294Z\" fill=\"#53CBC8\"></path><path d=\"M11.774 19.078c.208-.06.475-.073.621.12.197.283.197.64.202.97-.01 1.594-.003 3.19-.003 4.785-.002.324-.044.755-.379.905-.406.17-.832-.227-.823-.633-.014-1.774.003-3.55-.006-5.324-.016-.306.06-.709.388-.823ZM13.72 20.56c.022-.557-.133-1.247.385-1.628l.424.023.361.34c.022 3.785.004 7.572.01 11.358.021.27-.072.588-.364.672-.24.142-.476-.043-.702-.116-.045-.271-.091-.543-.094-.819.014-3.276-.033-6.553-.02-9.83ZM16.208 20.016c.147-.055.295-.112.441-.17.364.11.622.442.61.828.015 1.256.032 2.515-.01 3.772-.008.35-.283.588-.59.7-.151-.062-.302-.123-.455-.181-.106-.249-.2-.509-.179-.783.008-1.127.003-2.255.003-3.382-.016-.275.078-.535.18-.784ZM9.406 20.32c.408-.155.878.176.847.613.004 1.3.005 2.599-.002 3.898.048.428-.451.84-.846.615-.326-.163-.348-.567-.35-.887-.006-1.078.016-2.155.005-3.233.007-.352-.015-.813.346-1.006ZM18.417 21.682c.034-.276.337-.34.537-.454a3.5 3.5 0 0 1 .592.35c-.017.52-.013 1.04-.004 1.56-.178.14-.335.368-.588.351-.236.002-.436-.18-.529-.386a6.604 6.604 0 0 1-.008-1.421ZM25.407 22.246c.113-.605 1.133-.485 1.143.11.014.732.016 1.468 0 2.2.022.357-.355.479-.608.616-.24-.142-.568-.278-.557-.612-.02-.77-.055-1.548.022-2.314ZM20.955 22.272c.363-.337.94.04.95.485.025 1.723-.006 3.446.012 5.168-.01.324.046.702-.198.96-.234.28-.745.22-.92-.096-.143-.218-.11-.49-.121-.735.011-1.724 0-3.446.005-5.17a.725.725 0 0 1 .272-.612ZM23.036 22.701c.276-.362.93-.444 1.126.038.05 1.78-.004 3.563.026 5.345-.174.136-.329.338-.567.352-.251.012-.401-.218-.581-.353.001-1.795.01-3.588-.004-5.382Z\" fill=\"#53CBC8\"></path></svg>",
  },
  {
    "chain": "sentinel",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#sentinel_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#1C2D4F\"></path><path d=\"M8.008 8.347c.833-.004 1.666.006 2.499-.006 1.453-.009 2.907.01 4.36-.007H25.04c.986-.002 1.972.01 2.958.007 0 3.318.004 6.636-.002 9.953-.32-.21-.617-.452-.927-.675-3.4-2.52-6.802-5.035-10.201-7.555-.06-.04-.116-.107-.196-.1h-2.407c4.546 3.348 9.085 6.705 13.631 10.054.018.427-.08.848-.156 1.266-.056.222-.069.452-.132.673a8.396 8.396 0 0 1-1.152 2.604 13.016 13.016 0 0 1-2.594 2.877 11.772 11.772 0 0 1-3.31 1.965 9.087 9.087 0 0 1-2.524.598c-.822-.063-1.626-.271-2.397-.551-1.92-.714-3.616-1.956-4.956-3.483-.658-.763-1.246-1.593-1.681-2.5a8.329 8.329 0 0 1-.555-1.552c-.173-.694-.295-1.401-.356-2.113a34.732 34.732 0 0 1-.08-3.097c.006-.177-.013-.357.011-.534.9.676 1.812 1.336 2.715 2.008 3.624 2.674 7.25 5.348 10.873 8.023.22.16.436.327.66.483.416-.306.803-.649 1.174-1.005-3.378-2.505-6.76-5.005-10.14-7.508-1.765-1.302-3.523-2.612-5.289-3.913V8.347Z\" fill=\"#4AA1E4\"></path></g><defs><clipPath id=\"sentinel_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "polkadot",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z\" fill=\"#E6007A\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.003 10.454c2.61 0 4.724-1.221 4.724-2.727C22.727 6.22 20.612 5 18.003 5c-2.608 0-4.723 1.22-4.723 2.727 0 1.506 2.115 2.727 4.723 2.727Zm0 20.546c2.61 0 4.724-1.221 4.724-2.727 0-1.506-2.115-2.727-4.724-2.727-2.608 0-4.723 1.22-4.723 2.727 0 1.506 2.115 2.727 4.723 2.727ZM11.39 8.796c1.312.758 1.324 3.193.027 5.44-1.297 2.246-3.412 3.453-4.724 2.695-1.313-.757-1.325-3.193-.028-5.44 1.297-2.246 3.413-3.453 4.725-2.695ZM29.34 24.508c1.297-2.246 1.285-4.681-.026-5.439-1.312-.757-3.426.45-4.723 2.697-1.297 2.247-1.286 4.682.026 5.439 1.311.757 3.426-.45 4.723-2.697Zm-17.923-2.744c1.298 2.247 1.285 4.682-.027 5.44-1.313.758-3.428-.45-4.725-2.696-1.297-2.246-1.285-4.682.028-5.44 1.312-.757 3.427.45 4.724 2.696Zm17.898-4.831c1.311-.758 1.323-3.193.026-5.44-1.297-2.246-3.412-3.453-4.723-2.696-1.312.757-1.323 3.192-.026 5.439 1.297 2.246 3.412 3.454 4.723 2.697Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "tenet",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z\" fill=\"#1D1D1D\"></path><path d=\"M27.808 11.675a3.31 3.31 0 0 0-2.892-1.664H18.26a3.926 3.926 0 0 0-.26-.011c-.085 0-.172.006-.258.011h-6.658a3.31 3.31 0 0 0-2.892 1.664 3.27 3.27 0 0 0 0 3.32l6.917 11.906A3.31 3.31 0 0 0 18 28.564a3.31 3.31 0 0 0 2.892-1.663l6.916-11.905a3.27 3.27 0 0 0 0-3.321Zm-8.515 14.312c-.27.463-.753.743-1.293.743-.54 0-1.024-.28-1.294-.743l-3.892-6.7 3.892-6.703c.242-.418.65-.68 1.121-.732h.345c.472.051.88.32 1.121.732l3.893 6.698-3.893 6.705Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "shentu",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#E1AB4C\"></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.825 5h.25c.244.021.481.104.687.239 1.74 1.09 3.48 2.177 5.222 3.264a9366.366 9366.366 0 0 1 3.022 1.888c.187.113.374.226.543.366.312.279.481.707.447 1.124l-.317 5.186c-.21 3.458-.422 6.916-.636 10.373a1.38 1.38 0 0 1-.915 1.232c-.234.084-.482.08-.728.076a6.417 6.417 0 0 0-.236 0h-7.42l-7.42-.001c-.696.017-1.33-.571-1.365-1.267-.183-2.947-.363-5.893-.542-8.84L8 11.83v-.138c.028-.448.288-.867.671-1.098l3.437-2.157h.001l4.762-2.988.023-.015c.287-.19.582-.384.93-.434Zm-.122 2.3c-1.328.828-2.653 1.66-3.98 2.49-1.03.646-2.059 1.292-3.09 1.936l-.124.077c-.126.077-.253.154-.36.255-.132.14-.117.328-.103.507a4789.71 4789.71 0 0 1 .396 6.455c.148 2.42.295 4.84.446 7.26a.47.47 0 0 0 .504.444c4.413.002 8.827 0 13.24 0a.485.485 0 0 0 .465-.46c.272-4.5.546-8.998.82-13.497.002-.052.006-.105.01-.159.014-.177.028-.357-.063-.517a1.39 1.39 0 0 0-.372-.28 3.84 3.84 0 0 1-.144-.089L22.1 9.692h-.002l-3.805-2.379a.485.485 0 0 0-.591-.013Zm-2.415 4.395c-.913.57-1.825 1.14-2.732 1.718l.134 2.143c.075 1.193.15 2.386.221 3.58h7.475c-.055.835-.104 1.67-.152 2.505-1.496-.002-2.99-.001-4.486 0-.01-.18-.022-.359-.033-.538-.027-.429-.053-.856-.075-1.285H12.96c.042.83.093 1.658.144 2.486.042.672.084 1.344.12 2.017h9.535c.074-1.276.152-2.552.23-3.828.082-1.346.164-2.692.242-4.039-1.17.002-2.339.001-3.508 0-1.43 0-2.858 0-4.288.002-.039-.544-.07-1.09-.1-1.635.432-.265.862-.534 1.291-.803.454-.284.908-.568 1.364-.847.879.56 1.763 1.112 2.652 1.653-.016.331-.038.662-.061.994h2.683c.031-.472.06-.944.088-1.415l.06-.991c-.594-.371-1.188-.745-1.782-1.118-1.219-.767-2.437-1.534-3.67-2.278-.888.564-1.78 1.122-2.673 1.68Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "cro-chain",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#crypto_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#002D74\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 9.043V5.28L7 11.664v12.71l11 6.383v-3.819l-7.751-4.445v-8.948l7.75-4.502Zm0 17.896V30.7l11-6.383V11.664L18 5.281v3.762l7.751 4.445v8.948L18 26.94Zm0-3.022 5.187-2.964v-5.927L18 12.063l-5.129 2.963v5.927l5.13 2.964Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"crypto_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "coreum",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#coreum_svg__a)\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#56BF88\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.853 6h-.813c-2.683.104-5.321 1.125-7.356 2.88-.086.069-.167.145-.247.222-.135.13-.27.26-.437.35v.099c.148.1.273.228.397.356l.094.097a6542.441 6542.441 0 0 1 3.748 3.748c1.031-1.006 2.413-1.654 3.857-1.74 1.701-.118 3.447.531 4.638 1.757 1.15 1.121 1.788 2.734 1.754 4.337-.023 1.556-.679 3.099-1.805 4.177-1.259 1.27-3.121 1.891-4.892 1.677-1.336-.148-2.593-.779-3.554-1.712-.66.664-1.324 1.326-1.986 1.988-.751.75-1.502 1.501-2.251 2.254v.031c.118.071.217.167.314.263 2.103 1.98 4.949 3.131 7.832 3.216h.626a12.068 12.068 0 0 0 6.209-1.912 12.005 12.005 0 0 0 4.871-13.931 11.976 11.976 0 0 0-4.334-5.879C22.592 6.871 20.234 6.083 17.853 6Zm2.372 10.785c-.531-1.275-2.029-2.035-3.373-1.718-.939.2-1.76.875-2.128 1.763-.539 1.209-.139 2.741.918 3.538 1.142.93 2.953.811 3.973-.25.854-.852 1.126-2.234.61-3.333Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"coreum_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "assetmantle",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#F2AF14\"></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.714 9.429h8.571a2.571 2.571 0 0 1 2.092 4.063l-8.572 12A2.572 2.572 0 0 1 5.143 24V12A2.571 2.571 0 0 1 7.714 9.43Zm.762 5.71a1.714 1.714 0 1 0 1.905-2.85 1.714 1.714 0 0 0-1.905 2.85Z\" fill=\"#0D0A03\"></path><path d=\"M22.714 25.714a2.143 2.143 0 1 0 0-4.285 2.143 2.143 0 0 0 0 4.285Z\" fill=\"#0D0A03\"></path><path d=\"M30.857 12v12a2.571 2.571 0 1 1-5.143 0v-1.954a2.57 2.57 0 0 0-4.663-1.474l-1.337 1.877-2.152 3.017a2.571 2.571 0 0 1-4.165-3.009l8.571-12A2.571 2.571 0 0 1 24 9.43h4.285A2.572 2.572 0 0 1 30.857 12Z\" fill=\"#FFFDFA\"></path></svg>",
  },
  {
    "chain": "mars",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#mars_svg__a)\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#B73D3C\"></path><path d=\"m21.305 5.424.185.05a12.291 12.291 0 0 1 1.091.356 12.85 12.85 0 0 1 2.603 1.334l.023.015c.088.059.175.118.262.18l-.285-.195a12.961 12.961 0 0 1 .606.428l.034.025c.525.396 1.019.831 1.477 1.3l.04.041.245.26.045.05a13.053 13.053 0 0 1 1.149 1.464l.049.073.018.026a13.025 13.025 0 0 1 .955 1.71l.012.026c.417.905.733 1.868.934 2.873l-.078-.363A12.9 12.9 0 0 1 31 18c0 .102-.001.204-.003.305v.008l-.003.092a13.095 13.095 0 0 1-.067.979l-.005.046-.002.018a12.601 12.601 0 0 1-.157 1.036l-.014.072c-.07.347-.152.688-.248 1.024l-.018.062c-.054.187-.113.372-.175.555l-.032.092c-.077.22-.159.436-.247.65l.131-.333a12.887 12.887 0 0 1-1.169 2.34l-.034.052a13.063 13.063 0 0 1-1.882 2.31l-.037.036a13.041 13.041 0 0 1-2.98 2.161l-.078.041a12.998 12.998 0 0 1-.578.282l-.076.035a12.79 12.79 0 0 1-2.347.794l.35-.087a12.7 12.7 0 0 1-.736.171l-.021.005a12.471 12.471 0 0 1-1.168.179c-.108.012-.217.022-.326.031l-.04.003c-.11.009-.221.016-.332.022l-.04.002a13.193 13.193 0 0 1-1.637-.019l-.067-.005a13.44 13.44 0 0 1-.314-.028l.383.033a13.158 13.158 0 0 1-.78-.08l-.048-.007a12.756 12.756 0 0 1-.746-.125l-.016-.004c-.12-.024-.239-.05-.357-.076l-.055-.013a12.864 12.864 0 0 1-2.219-.736l.337.14a13.128 13.128 0 0 1-1.492-.714 13.048 13.048 0 0 1-3.028-2.341l-.06-.063a13.075 13.075 0 0 1-1.298-1.604l-.026-.038a12.7 12.7 0 0 1-.903-1.549 12.906 12.906 0 0 1-1.18-3.709l-.003-.016.003.017a13.038 13.038 0 0 1-.154-2.453L5 18a13.232 13.232 0 0 1 .235-2.471 12.907 12.907 0 0 1 1.206-3.485l-.15.3A12.944 12.944 0 0 1 8.297 9.35a13.077 13.077 0 0 1 1.99-1.815l-.25.19a13.005 13.005 0 0 1 .572-.42l.028-.02.095-.064c.33-.223.671-.431 1.022-.624l.073-.04a12.925 12.925 0 0 1 1.54-.706l.02-.008a13.494 13.494 0 0 1 .34-.124l.076-.026a12.864 12.864 0 0 1 2.426-.572 13.115 13.115 0 0 1 3.581.005l-.35-.044a13.035 13.035 0 0 1 1.732.314l.016.004-.016-.004.113.029Zm-3.068 22.877v1.21a11.517 11.517 0 0 0 2.655-.363l-2.655-.847Zm-.743 0-2.536.807c.813.222 1.662.358 2.537.395V28.3Zm5.044-2.85-3.772 2.24 3.35 1.066c.152-.059.304-.12.454-.185l-.032-3.121Zm-9.347-.002-.03 3.002c.197.091.397.177.6.258l3.204-1.02-3.774-2.24Zm10.149-.109.01.076-.07-.032.028 2.836a11.547 11.547 0 0 0 2.728-1.974l-2.696-.906Zm-10.95-.002-2.497.839c.75.742 1.6 1.383 2.529 1.898l.025-2.692-.066.03.008-.075Zm5.847-2.266v4.069l3.868-2.296-3.868-1.773Zm-.743-.001-3.87 1.772 3.87 2.298v-4.07Zm9.436-1.312-3.297 2.896 2.97.998c.104-.117.206-.236.305-.357l.022-3.537Zm-18.129 0 .018 3.191c.164.217.336.427.515.631l2.76-.927L8.8 21.759Zm18.873-.316-.017 2.83c.493-.757.9-1.576 1.205-2.443l-1.188-.387Zm-5.705-1.472-3.372 2.448 3.862 1.771-.49-4.22Zm-8.207 0-.491 4.217 3.862-1.769-3.37-2.449Zm-.73-.144-3.873 1.258 3.38 2.97.492-4.228Zm9.668 0 .491 4.228 3.381-2.97-3.872-1.258ZM8.056 21.444l-.945.307c.25.73.573 1.426.959 2.08l-.014-2.387Zm9.438-3.067-3.22 1.046 3.22 2.34v-3.386Zm.743 0v3.385l3.22-2.339-3.22-1.046Zm11.266.133-1.598 2.227 1.181.383c.235-.835.378-1.71.417-2.61ZM6.892 21.04l.935-.303-1.305-1.817c.057.728.183 1.437.37 2.12Zm3.027-5.05-.988 4.389 3.87-1.258-2.882-3.13Zm15.892.002-2.88 3.128 3.87 1.258-.99-4.386ZM9.21 15.765l-2.638.83c-.04.332-.067.669-.079 1.01l1.752 2.44.965-4.28Zm17.314.003.964 4.277 2.003-2.792c-.012-.191-.029-.381-.05-.57l-2.917-.915Zm-11.249-.837-1.23 3.785 3.22-1.046-1.99-2.739Zm5.182.001-1.99 2.738 3.219 1.045-1.229-3.783Zm-5.859-.318-4.164.837 2.877 3.127 1.287-3.964Zm6.537 0 1.288 3.964 2.876-3.124-4.164-.84Zm-1.279-.118h-3.978l1.989 2.737 1.99-2.737Zm8.42-1.698-1.61 2.173.073.015-.05.054 2.63.827a11.432 11.432 0 0 0-1.043-3.069ZM6.701 15.775l2.343-.737-.05-.054.073-.015-1.45-1.954a11.43 11.43 0 0 0-.916 2.76Zm16.917-5.194-2.393 3.294 4.172.84-1.78-4.134Zm-11.505 0-1.78 4.133 4.174-.84-2.394-3.294Zm12.257-.131 1.734 4.03 1.777-2.395a11.523 11.523 0 0 0-.386-.6L24.37 10.45Zm-13.009-.002-2.774.92c-.21.295-.404.602-.585.917l1.624 2.191 1.735-4.028Zm6.505-.397-2.085 3.703h4.17l-2.085-3.703Zm.671-.323 2.087 3.709 2.393-3.293-4.48-.416Zm-1.343 0-4.48.416 2.394 3.293 2.086-3.709Zm7.723-.934-.618.849 2.377.787a11.584 11.584 0 0 0-1.76-1.636Zm-15.48 1.508 1.994-.66-.52-.716c-.53.415-1.024.876-1.474 1.377Zm10.738-3.611-1.632 2.292 4.37.405-1.83-2.485a11.429 11.429 0 0 0-.908-.212Zm-5.6.313-1.753 2.384 4.366-.405-1.598-2.245c-.345.074-.683.162-1.016.266ZM11.51 8.487l.522.718 1.263-1.718c-.626.281-1.223.616-1.785 1ZM22.314 7.32 23.7 9.205l.609-.839a11.482 11.482 0 0 0-1.995-1.045ZM18 6.486c-.543 0-1.076.037-1.6.11L17.83 8.6l.037-.064.036.064 1.45-2.037A11.635 11.635 0 0 0 18 6.486Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"mars_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "teritori",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#4E46FF\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m12.479 14.63 4.19.364V7.588A.588.588 0 0 0 16.081 7h-3.674a.588.588 0 0 0-.584.644l.655 6.987Zm1.345 14.353a.59.59 0 0 0 .196.386l1.673 1.483a.586.586 0 0 0 .975-.442V17.122h-3.956l1.112 11.861ZM24.4 16.886h3.016a.294.294 0 0 0 .293-.294v-1.735c0-.174-.15-.31-.322-.293l-2.8.274-.187 2.048Zm-4.458 0v-1.593l-1.158.113a.299.299 0 0 1-.053 0l-9.876-.847a.294.294 0 0 0-.318.294v1.739c0 .162.131.294.293.294h11.112Zm1.239 13.925a.587.587 0 0 1-1.005-.413V12.143h4.427l-1.54 16.565a.59.59 0 0 1-.166.359L21.18 30.81ZM20.176 9.136V7.589c0-.325.263-.589.587-.589h3.674c.346 0 .616.298.584.643l-.11 1.196-4.735.296Zm-3.273 2.773h11.862c.13 0 .235-.106.235-.236V9.057a.235.235 0 0 0-.25-.234l-10.187.649-1.66-.082v2.518Zm-4.915 0-.282-2.775-4.46-.22A.235.235 0 0 0 7 9.148v2.524c0 .13.105.236.235.236h4.753Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "chihuahua",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#F6D355\"></circle><path d=\"M15.713 6.22c2.905-.524 5.983-.109 8.625 1.199.619.298 1.211.65 1.776 1.038-1.632.63-3.016 1.792-4.033 3.186-.984-.389-2.02-.659-3.079-.744a10.37 10.37 0 0 0-5.248.902 2.315 2.315 0 0 1-.234.08c-.954-1.302-2.233-2.396-3.737-3.036a13.812 13.812 0 0 1 5.93-2.624ZM23.527 12.401c1.75-1.61 3.992-2.673 6.343-3.096.106-.01.224-.03.322.024.107.065.115.203.122.313-.042 2.037-.287 4.088-.943 6.027-.282.826-.674 1.621-1.21 2.316-.146.182-.271.377-.42.556-.049-.229-.092-.46-.149-.687.56-.742.921-1.611 1.175-2.497.433-1.486.601-3.034.628-4.576-.002-.12-.02-.288-.164-.32-.225-.037-.449.041-.668.081-1.696.358-3.327 1.048-4.722 2.069a11.42 11.42 0 0 1-.314-.21ZM6.118 9.514c.092-.103.247-.077.37-.066 2.269.42 4.425 1.44 6.143 2.961-.12.086-.244.167-.368.248-1.422-.956-3.059-1.584-4.75-1.89-.121-.016-.262-.04-.366.042-.12.174-.067.396-.067.593.041 1.214.159 2.43.452 3.612.227.957.54 1.91 1.072 2.748-.062.241-.116.484-.16.729-.146-.106-.224-.274-.338-.409-.884-1.177-1.326-2.606-1.622-4.024-.303-1.387-.408-2.808-.441-4.224.004-.109.005-.23.075-.32Z\" fill=\"#F6D355\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M31.106 14.76c-.658 1.848-1.813 3.481-3.148 4.915a3.493 3.493 0 0 0-1.586-1.312 3.535 3.535 0 0 0-2.534-.061 3.458 3.458 0 0 0-1.702 1.314 3.344 3.344 0 0 0-.578 1.907c-.005.74.254 1.478.712 2.064a3.445 3.445 0 0 0 1.855 1.22 3.54 3.54 0 0 0 2.41-.222 9.285 9.285 0 0 1-1.88 2.17c-.483.403-.996.782-1.56 1.069-.296.737-.888 1.37-1.648 1.657-1.04.388-2.182.568-3.287.386a4.14 4.14 0 0 1-2-.922c-2.17-.395-4.2-1.52-5.64-3.17-1.23-1.395-2.021-3.17-2.172-5.016a.641.641 0 0 1-.006-.052c-.005-.054-.01-.11-.052-.148-1.401-1.353-2.62-2.919-3.42-4.691a13.094 13.094 0 0 0-.788 5.28c.097 1.796.602 3.57 1.466 5.155 1.44 2.658 3.813 4.76 6.525 6.118 1.792.889 3.758 1.49 5.771 1.572 1.256.05 2.507-.183 3.697-.566a15.706 15.706 0 0 0 4.802-2.593c1.48-1.165 2.752-2.592 3.682-4.22.412-.707.735-1.46 1.016-2.227 1.29-3.042 1.247-6.56.065-9.626Zm-8.74 6.714a2.682 2.682 0 0 1 .595-1.902 2.753 2.753 0 0 1 2.127-1.01 2.751 2.751 0 0 1 1.991.813 2.682 2.682 0 0 1 .143 3.627 2.764 2.764 0 0 1-2.084.97c-.467.01-.93-.11-1.343-.323-.183.183-.506.202-.697.02-.176-.156-.186-.432-.066-.624a2.701 2.701 0 0 1-.666-1.571Z\" fill=\"#F6D355\"></path><ellipse cx=\"19.316\" cy=\"29.047\" rx=\"2.124\" ry=\"1.714\" fill=\"#EA8664\"></ellipse><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.207 18.587a3.565 3.565 0 0 0-1.871-.291 3.482 3.482 0 0 0-2.555 1.619c-.44.716-.604 1.592-.44 2.414.132.677.474 1.313.977 1.794a3.505 3.505 0 0 0 2.643.97c1.32-.064 2.556-.944 3.02-2.164a3.37 3.37 0 0 0-.085-2.68 3.425 3.425 0 0 0-1.689-1.662Zm-3.67 1.36a2.763 2.763 0 0 1 1.895-1.182 2.799 2.799 0 0 1 2.125.566c.562.438.93 1.105 1.009 1.805a2.665 2.665 0 0 1-.295 1.562 2.736 2.736 0 0 1-1.609 1.325 2.786 2.786 0 0 1-1.9-.09c-.306.145-.689-.08-.701-.414a2.687 2.687 0 0 1-.524-3.572Z\" fill=\"#F6D355\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m29.15 7.71-.046.008c-1.014.167-2.031.363-2.99.739-1.632.63-3.016 1.792-4.032 3.186-.984-.39-2.02-.659-3.08-.744a10.37 10.37 0 0 0-5.247.901 2.317 2.317 0 0 1-.235.08c-.954-1.301-2.233-2.395-3.736-3.035-1.022-.44-2.124-.66-3.22-.84a42.412 42.412 0 0 1-.143-.024c-.453-.077-.914-.155-1.372-.084-.22.036-.456.132-.567.334-.088.148-.085.32-.082.486.001.04.002.08.001.12.012.516-.092 1.019-.195 1.521-.082.393-.163.785-.189 1.185-.1 1.483.24 2.973.852 4.325.8 1.772 2.02 3.338 3.42 4.691.043.038.048.094.053.148.001.018.003.035.006.052.15 1.845.942 3.621 2.17 5.017 1.44 1.649 3.472 2.774 5.641 3.169-.595-.503-1.091-1.174-1.213-1.952-.098-.578.047-1.17.314-1.687.196-.388.438-.762.77-1.052.148-.132.312-.248.475-.363.21-.148.418-.295.597-.48.416-.416.643-.981.741-1.55.135-.793.084-1.596.034-2.396a29.54 29.54 0 0 1-.046-.843c-.008-.456-.014-.923.12-1.364.1-.306.293-.596.574-.766a.566.566 0 0 1 .601.015c.318.204.522.544.621.898.144.505.168 1.032.19 1.553l.003.046.013.376c.024.737.049 1.476.202 2.199.116.542.316 1.08.668 1.519.2.248.445.45.69.652.106.087.211.174.313.264.325.285.605.618.841.978.215.327.427.664.535 1.041.172.587.112 1.224-.107 1.79.564-.286 1.076-.665 1.56-1.067a9.285 9.285 0 0 0 1.88-2.17 3.54 3.54 0 0 1-2.41.22 3.445 3.445 0 0 1-1.855-1.219 3.341 3.341 0 0 1-.712-2.064 3.344 3.344 0 0 1 .577-1.907 3.458 3.458 0 0 1 1.703-1.314 3.535 3.535 0 0 1 2.534.061c.65.264 1.203.734 1.585 1.312 1.336-1.434 2.49-3.067 3.148-4.914a9.258 9.258 0 0 0 .54-2.933 7.75 7.75 0 0 0-.2-1.706c-.127-.58-.238-1.172-.205-1.769.012-.194-.037-.407-.191-.54-.19-.17-.456-.21-.702-.224-.402-.014-.801.054-1.196.121Zm-5.309 4.9c-.106-.068-.21-.137-.314-.21 1.75-1.61 3.992-2.672 6.343-3.096l.032-.003c.097-.01.202-.02.29.028.106.065.115.202.122.312v.001c-.042 2.037-.288 4.088-.944 6.027-.282.826-.673 1.621-1.21 2.316-.068.085-.13.172-.194.26-.073.1-.145.2-.224.296-.017-.075-.032-.15-.047-.224-.033-.155-.065-.31-.103-.463-.541-2.124-1.923-4.006-3.75-5.243ZM6.117 9.514c-.066.086-.07.199-.074.303v.017c.033 1.416.137 2.837.44 4.224.296 1.418.739 2.847 1.623 4.024.04.047.075.098.11.149.066.095.132.19.227.26.044-.245.099-.488.16-.729.548-2.061 1.893-3.884 3.66-5.105.123-.08.247-.162.368-.247-1.718-1.522-3.875-2.541-6.143-2.962l-.033-.003c-.117-.012-.253-.025-.338.069ZM9.78 19.915a3.482 3.482 0 0 1 2.556-1.62 3.565 3.565 0 0 1 1.87.293c.741.332 1.35.933 1.69 1.66a3.37 3.37 0 0 1 .085 2.68c-.464 1.221-1.7 2.101-3.02 2.166a3.505 3.505 0 0 1-2.643-.971 3.395 3.395 0 0 1-.978-1.794 3.39 3.39 0 0 1 .44-2.414Z\" fill=\"#373636\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.088 18.564a2.753 2.753 0 0 0-2.127 1.01 2.682 2.682 0 0 0 .07 3.472c.148-.19.433-.264.645-.135.267.139.316.523.119.74.412.212.876.332 1.343.322.794-.001 1.579-.367 2.084-.97a2.683 2.683 0 0 0-.143-3.626 2.751 2.751 0 0 0-1.991-.813Zm-.047 1.676c-.14-.412.123-.904.551-1.017.456-.156.996.169 1.06.64.09.433-.242.893-.69.946-.395.07-.814-.188-.92-.569ZM14.557 19.332a2.799 2.799 0 0 0-2.125-.567c-.766.104-1.47.55-1.896 1.183a2.686 2.686 0 0 0 .525 3.572c-.027-.357.406-.626.72-.44.343.164.327.703-.02.855a2.786 2.786 0 0 0 1.901.09 2.736 2.736 0 0 0 1.608-1.327 2.665 2.665 0 0 0 .296-1.56 2.694 2.694 0 0 0-1.009-1.806Zm-1.825.858a.805.805 0 0 1 .576-.79c.277-.092.6-.02.813.177a.81.81 0 0 1 .174.975.807.807 0 0 1-.751.436c-.433.015-.825-.373-.812-.798Z\" fill=\"#373636\"></path><path d=\"M18.836 25.362a5.41 5.41 0 0 1 2.093.2c.207.057.317.31.222.498-.183.37-.48.674-.815.913-.316.227-.733.259-1.106.187-.493-.097-.936-.358-1.318-.671-.122-.108-.24-.239-.272-.402-.042-.241.136-.478.365-.55a3.73 3.73 0 0 1 .83-.175Z\" fill=\"#373636\"></path><path d=\"M28.564 10.542c.219-.04.442-.118.668-.081.143.032.162.2.163.32-.026 1.542-.194 3.09-.628 4.576-.253.886-.614 1.755-1.174 2.497-.541-2.124-1.924-4.006-3.751-5.244 1.394-1.02 3.025-1.71 4.722-2.068ZM7.147 10.808c.104-.082.245-.058.367-.042 1.69.307 3.327.935 4.75 1.89-1.768 1.22-3.112 3.044-3.66 5.105-.532-.838-.844-1.79-1.072-2.748-.293-1.182-.41-2.397-.452-3.611 0-.198-.053-.42.067-.594Z\" fill=\"#FFFFFE\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.127 16.507a.566.566 0 0 0-.601-.015c-.282.17-.475.46-.574.766-.135.441-.129.908-.12 1.364.01.28.027.562.045.843.05.8.101 1.603-.034 2.397-.098.568-.324 1.134-.74 1.55-.18.184-.388.331-.598.48a5.24 5.24 0 0 0-.475.363c-.332.289-.574.663-.77 1.05-.266.517-.411 1.11-.313 1.688.121.778.618 1.45 1.213 1.952a4.14 4.14 0 0 0 2 .922c1.105.183 2.247.002 3.288-.386.759-.287 1.35-.92 1.647-1.657.22-.567.28-1.204.108-1.79-.109-.378-.32-.715-.535-1.042a4.789 4.789 0 0 0-.841-.978c-.102-.09-.208-.177-.313-.264-.246-.202-.491-.404-.69-.652-.353-.44-.552-.977-.669-1.52-.153-.722-.177-1.461-.202-2.198l-.013-.376-.002-.046c-.023-.521-.047-1.048-.19-1.553-.1-.354-.304-.694-.622-.898Zm-1.121 9.029c.269-.09.548-.149.83-.175a5.408 5.408 0 0 1 2.094.2c.207.058.316.31.221.499-.182.369-.48.673-.815.913-.316.227-.732.258-1.105.186-.494-.096-.937-.357-1.318-.67-.123-.109-.241-.24-.273-.403-.041-.24.137-.478.366-.55Z\" fill=\"#FFFFFE\"></path><path d=\"M25.592 19.22c.456-.154.996.17 1.06.64.09.434-.242.895-.69.947-.394.07-.814-.187-.92-.569-.14-.412.122-.904.55-1.017ZM13.308 19.4c.278-.092.601-.02.814.177a.81.81 0 0 1 .174.975.807.807 0 0 1-.751.436c-.433.015-.825-.374-.812-.799a.805.805 0 0 1 .575-.79ZM23.032 23.044c.146-.19.432-.264.644-.135.267.14.316.523.119.74-.183.183-.506.201-.697.02-.176-.156-.186-.432-.066-.625ZM11.062 23.52c-.027-.357.406-.627.72-.44.343.164.326.702-.02.854-.305.144-.688-.081-.7-.415Z\" fill=\"#FFFFFE\"></path></svg>",
  },
  {
    "chain": "persistence",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#000\"></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.9 35.734a17.883 17.883 0 0 1-6.04-2.224V11.503h9.785c1.978 0 3.65.337 5.016 1.01 1.366.674 2.39 1.603 3.073 2.787.683 1.185 1.024 2.544 1.024 4.076 0 1.417-.33 2.718-.989 3.902-.66 1.162-1.672 2.102-3.038 2.822-1.366.72-3.061 1.08-5.086 1.08H14.9v8.554Zm3.285-13.292c1.154 0 2.014-.267 2.579-.8.565-.535.848-1.29.848-2.265 0-.976-.283-1.73-.848-2.265-.566-.534-1.425-.801-2.58-.801H14.9v6.131h3.285Z\" fill=\"#fff\"></path><path d=\"M28 6H8.86v4.161H28V6Z\" fill=\"#C33B3D\"></path></svg>",
  },
  {
    "chain": "sifchain",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 36C8.075 36 0 27.924 0 18S8.075 0 18 0s18 8.076 18 18-8.075 18-18 18Z\" fill=\"#C6A440\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.092 29.687a.34.34 0 1 1-.065.678c-.875-.088-3.365-.331-4.03-.294-1.521.09-2.732-.695-2.732-2.09 0-1.253.087-1.506.409-2.45l.073-.215C9.255 24.368 9 23.26 9 22.006c0-1.199.2-2.273.62-3.22.419-.931.874-1.7 1.366-2.273a5.589 5.589 0 0 1 1.822-1.396 5.317 5.317 0 0 1 2.296-.519c1.076 0 1.968.286 2.643.859l2.824-2.308a13.802 13.802 0 0 1-.091-1.485c0-3.454.966-5.19 2.824-5.172.51 0 .93.18 1.221.537.274.358.438.787.474 1.324.018.77-.237 1.521-.729 2.273-.474.698-1.166 1.485-2.077 2.326.455 3.06.692 5.171.692 6.28 0 1.128-.146 2.237-.437 3.293a9.63 9.63 0 0 1-1.348 2.899c-.62.876-1.477 1.556-2.533 2.057-1.057.483-2.296.734-3.7.734-1.876 0-3.352-.59-4.391-1.771-.039.163-.072.29-.099.397-.114.445-.138.537-.138 1.374 0 1.056 1.061 1.206 2.154 1.206.462 0 2.777.19 3.699.266Zm7.941-21.262c0-.877-.4-.984-.692-.984-.893 0-1.33 1.038-1.33 3.06 0 .322.018.733.072 1.234 1.294-1.306 1.95-2.415 1.95-3.31Zm-6.414 9.448c0 1.002-.383 1.914-1.148 2.72-.51.554-1.075.84-1.677.84h-.218l.036.215c.037.197.11.358.237.465.11.108.274.161.474.161a3.38 3.38 0 0 0 2.059-.68c.583-.447 1.002-.966 1.22-1.556.238-.573.347-1.253.347-1.986 0-.698-.2-1.325-.583-1.897l2.296-1.879c.255 2.613.383 4.187.383 4.724 0 2.219-.474 4.151-1.422 5.708a5.01 5.01 0 0 1-1.968 1.86c-.838.448-1.822.68-2.933.68-1.786 0-3.062-.626-3.9-1.914a13.64 13.64 0 0 1 2.533-4.366c1.111-1.306 2.496-2.666 4.118-4.044.11.305.146.627.146.949Zm-4.646-1.736c-1.221.715-2.114 1.968-2.66 3.686a7.316 7.316 0 0 0-.347 2.272c0 .698.091 1.342.274 1.95 1.111-2.469 3.37-5.117 6.705-7.926-.437-.376-1.02-.573-1.75-.573-.82 0-1.566.197-2.222.59Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "syscoin",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#syscoin_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#3367F6\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.832 10.066c2.557-1.025 6.455-1.17 11.482.432A14.104 14.104 0 0 0 16.12 7.752c-1.002.17-1.982.45-2.923.833a7.834 7.834 0 0 0-.039.02l.035-.02a12.301 12.301 0 0 0-3.428 2.057C5.14 14.65 6.233 20.953 13.676 22.98c.408.114.824.2 1.245.256 3.79.488 4.881-2.19 1.372-3.92a9.613 9.613 0 0 1-2.212-1.484 6.179 6.179 0 0 1-.255-.224l.088.073.155.127c-2.89-2.678-2.08-6.18 1.723-7.741h.04Zm4.372 15.87a7.808 7.808 0 0 0 1.185-.6c3.394-2.128 3.13-6.215-1.667-8.606-3.862-1.925-2.156-4.984 2.61-3.683-.041-.011.041.011 0 0-.04-.016.043.004 0-.007 1.72.419 3.309 1.253 4.629 2.43l.066.104c2.913 2.804 2.562 6.904-.8 9.802-.618.53-1.291.994-2.008 1.38a.067.067 0 0 0 .021-.03l-.017.015a12.74 12.74 0 0 1-1.434.68 14.252 14.252 0 0 1-3.701.949 14.163 14.163 0 0 1-10.406-2.862c3.91 1.24 7.146 1.433 9.587.973a10.062 10.062 0 0 0 1.895-.545.117.117 0 0 0 .04 0Zm.236-.095.074-.032-.033.015-.041.017Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"syscoin_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "comdex",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#FE4350\"></circle><path d=\"M27.138 21.726H14.442v-6.85H12.48v7.802c0 .514.44.94.982.94h11.135l-2.302 2.003H9.95V14.286H22.66a.999.999 0 0 0 .654-.237l4.48-3.896a.94.94 0 0 0 .264-1.04.984.984 0 0 0-.919-.613H13.461c-.541 0-.982.426-.982.94v2.354h1.95v-1.403h10.155l-2.303 2.004h-13.3c-.54 0-.981.426-.981.94V26.56c0 .513.44.939.981.939H22.66a.998.998 0 0 0 .654-.238l4.48-3.895a.94.94 0 0 0 .264-1.04 1.012 1.012 0 0 0-.919-.6Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "nolus",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><path d=\"M18 0a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z\" fill=\"#F50\"></path><path d=\"M24.293 26.999H11.707a2.706 2.706 0 0 1-2.706-2.707V11.706A2.706 2.706 0 0 1 11.707 9h12.586A2.706 2.706 0 0 1 27 11.706v12.586A2.706 2.706 0 0 1 24.293 27Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "bitcanna",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#52B489\"></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.93 19.556V20.7l-1.427 1.718-.407 2.134-.51.572a6.698 6.698 0 0 1-4.637 1.822h-.306a7.64 7.64 0 0 1-4.688-1.613 7.283 7.283 0 0 1-2.751-5.362h-.051a.69.69 0 0 1-.051-.312v-3.071L6 8l3.72 1.301v3.904l-.56 2.447.662 2.655v1.3a3.921 3.921 0 0 0 1.77 3.134 3.752 3.752 0 0 0 3.53.302c1.295-.635 2.125-1.967 2.14-3.435v-1.354l1.375-1.873.408-1.822.51-.573h.101a6.466 6.466 0 0 1 1.733-1.197 8.304 8.304 0 0 1 3.108-.625h.51c1.783.09 3.47.85 4.738 2.134h.102L27.3 16.901h-.05a4.044 4.044 0 0 0-2.14-1.093h-.51a3.682 3.682 0 0 0-2.65 1.145l-.204.26h-.05a3.59 3.59 0 0 0-.765 2.343Zm-11.16-3.8.51 1.926.102-.157a3.412 3.412 0 0 1 2.293-1.561h.051a3.393 3.393 0 0 1 1.02-.104 3.763 3.763 0 0 1 1.477.468 5.38 5.38 0 0 1 1.63 1.406l.102.104 1.172-1.718.357-1.822-.153-.104a7.203 7.203 0 0 0-2.7-1.614 6.4 6.4 0 0 0-1.682-.312h-.051a7.617 7.617 0 0 0-3.669.99l-.51 2.29.052.208Zm17.632 6.35H27.3c-.334.39-.753.693-1.223.885h-.05c-.417.19-.87.28-1.326.26a3.653 3.653 0 0 1-1.936-.416h-.153a3.5 3.5 0 0 1-1.376-1.353v-.104l-1.274 1.301s-.254 1.301-.356 1.926h.05a6.512 6.512 0 0 0 4.943 2.238h.204a7.116 7.116 0 0 0 3.516-.937 7.997 7.997 0 0 0 1.63-1.145h.052l-2.599-2.654Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "bahamut",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#bahamut_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#FF008C\"></path><path d=\"M14.73 29.064a1.65 1.65 0 0 1-1.387-2.605l4.16-5.722-6.808-.665a1.83 1.83 0 0 1-1.595-1.26 1.858 1.858 0 0 1 .513-1.982l10.608-9.49c.301-.28.698-.434 1.109-.43.436.006.854.18 1.165.485a1.676 1.676 0 0 1 .166 2.12l-4.16 5.722 6.808.65a1.87 1.87 0 0 1 1.082 3.243l-10.593 9.504a1.705 1.705 0 0 1-1.068.43Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"bahamut_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "regen",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#6DB47B\"></circle><g fill=\"#fff\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.822 13.47v-.017l-.005-.01-1.513-8.037L14.044 5l-.79 1.073 3.563 7.37.005.026Zm1.47-.26-.646-3.122.662-.504.678.455-.694 3.17Zm4.15-2.57-.823.082-.97 3.089 2.133-2.422-.34-.748Zm7.042-.666v1.317l-7.252 3.918 5.976-5.641 1.276.406Zm-14.6 4.65-1.776-2.683-.808.13-.129.813 2.713 1.74Zm8.253 3.364 3.181-.634.485.667-.485.666-3.181-.699Zm-9.674.017-8.172-1.04-.791 1.072.791 1.073 8.172-1.105Zm-3.262 2.552.242-.764 3.246-.342-2.826 1.593-.662-.487Zm1.179 1.495-.033.813.776.276 2.26-2.39-3.003 1.301Zm1.663 1.935 2.407-2.13-1.373 2.942-.824-.032-.21-.78Zm5.265-1.187-.646 3.154.662.471.662-.488-.678-3.137Zm3.925-1.967 7.267 3.885v1.317l-1.26.406-6.007-5.608Zm-.743 4.487-1.631-2.748.371 3.154.775.244.485-.65Zm-8.188 4.649 3.537-7.397-1.486 8.063-1.26.407-.791-1.073Z\"></path><path d=\"M16.822 13.453h.2v-.046l-.02-.041-.18.087Zm0 .016-.196.037.396-.037h-.2Zm-1.518-8.063.197-.037-.022-.116-.113-.037-.062.19ZM14.044 5l.062-.19-.137-.045-.085.116.16.119Zm-.79 1.073-.162-.119-.071.097.052.109.18-.087Zm4.392 4.015-.121-.16-.1.077.025.124.196-.041Zm.646 3.121-.196.04.391.003-.195-.043Zm.016-3.625.112-.166-.12-.08-.113.087.121.16Zm.678.455.196.043.029-.133-.113-.076-.111.166Zm2.633.683-.02-.199-.131.013-.04.126.19.06Zm.823-.081.183-.083-.06-.13-.142.014.02.199Zm-1.792 3.17-.191-.06.341.192-.15-.132Zm2.132-2.422.15.132.085-.097-.053-.118-.182.083Zm6.702-.098.095.176.105-.057v-.119h-.2Zm0-1.317h.2v-.146l-.14-.044-.06.19Zm-7.252 5.235-.137-.146.233.322-.095-.176Zm5.976-5.641.06-.19-.112-.036-.085.08.137.146Zm-15.1 2.373.167-.11-.072-.108-.127.02.032.198Zm1.776 2.682-.108.169.275-.28-.167.111ZM12.3 12.071l-.031-.197-.143.023-.023.143.197.031Zm-.129.813-.197-.031-.02.129.11.07.107-.168Zm14.148 4.47.161-.117-.075-.104-.126.025.04.196Zm-3.182.634-.04-.196-.003.392.043-.196Zm3.666.033.162.117.085-.117-.085-.118-.162.118Zm-.485.666-.042.196.127.028.077-.106-.162-.118ZM5.291 16.964l.026-.198-.117-.015-.07.095.161.118Zm8.172 1.04.027.199-.002-.397-.025.199Zm-8.963.033-.16-.119-.089.12.088.118.161-.119Zm.791 1.073-.16.119.07.095.117-.016-.027-.198Zm5.152.683-.02-.2-.131.015-.04.124.191.06Zm-.242.764-.19-.06-.044.136.115.085.119-.161Zm3.488-1.106.098.174-.119-.373.021.2Zm-2.826 1.593-.119.161.105.077.112-.063-.098-.175Zm.485 1.821-.2-.008-.006.147.138.05.068-.189Zm.032-.813-.08-.183-.115.05-.005.125.2.008Zm.743 1.09-.067.188.122.044.09-.095-.145-.138Zm2.26-2.39.146.137-.225-.32.08.183Zm1.067 1.105.18.085-.313-.235.133.15Zm-2.407 2.13-.132-.15-.093.082.032.12.193-.052Zm1.034.813-.008.2.133.005.056-.121-.181-.085Zm-.824-.033-.193.052.038.142.147.006.008-.2Zm4.41 1.187-.197-.04-.026.127.106.076.116-.163Zm.645-3.154.196-.042-.392.002.196.04Zm.016 3.625-.116.163.118.084.117-.086-.119-.161Zm.662-.488.12.161.103-.076-.027-.127-.195.042ZM29.5 24.718h.2v-.12l-.106-.056-.094.176Zm-7.267-3.885.094-.176-.23.322.136-.146Zm7.267 5.202.061.19.139-.045v-.145h-.2Zm-1.26.406-.136.146.086.08.112-.035-.062-.19Zm-8.381-3.869.171-.102-.37.126.198-.024Zm1.63 2.748.161.12.08-.108-.068-.114-.172.102Zm-1.259.406-.199.024.016.128.123.039.06-.19Zm.775.244-.06.19.136.043.085-.114-.16-.12Zm-4.166-3.398.196.037-.377-.123.18.086Zm-3.537 7.397-.18-.087-.053.109.072.096.16-.118Zm2.05.666.062.19.114-.036.021-.117-.196-.037Zm-1.259.407-.16.118.085.116.136-.044-.061-.19Zm2.53-17.589v.016h.4v-.016h-.4Zm.014.077.005.01.36-.174-.005-.01-.36.174Zm-1.53-8.087 1.514 8.037.393-.074L15.5 5.369l-.393.074Zm-1.124-.253 1.26.407.123-.38-1.26-.407-.123.38Zm-.569 1.002.792-1.073-.322-.238-.792 1.073.322.238Zm3.583 7.164-3.564-7.37-.36.174 3.564 7.37.36-.174Zm.022.076-.005-.026-.393.074.005.026.393-.074Zm.431-3.303.646 3.12.392-.08-.646-3.122-.392.082Zm.737-.704-.662.504.242.318.662-.504-.242-.318Zm.91.448-.677-.455-.223.332.678.455.223-.332Zm-.61 3.379.695-3.17-.39-.086-.695 3.17.39.086Zm3.152-2.33.823-.082-.04-.398-.823.081.04.398Zm-.798 2.948.969-3.088-.382-.12-.969 3.089.382.12Zm1.79-2.614L20.5 13.678l.3.265 2.132-2.422-.3-.265Zm-.37-.533.338.748.365-.165-.34-.748-.364.165Zm7.423.568V9.974h-.4v1.317h.4Zm-7.356 4.094 7.25-3.918-.19-.352-7.25 3.918.19.352Zm5.743-5.963-5.976 5.641.275.291 5.975-5.64-.274-.292Zm1.474.362-1.276-.407-.122.381 1.276.407.122-.381ZM12.94 12.052l1.777 2.682.333-.221-1.776-2.682-.334.22Zm-.609.217.808-.13-.064-.395-.807.13.063.395Zm.037.646.129-.812-.395-.063-.13.813.396.062Zm2.623 1.54-2.713-1.74-.216.337 2.713 1.74.216-.337Zm11.287 2.703-3.181.634.078.392 3.182-.634-.079-.392Zm.686.745-.485-.666-.323.235.484.666.324-.235Zm-.485.902.485-.666-.324-.236-.484.667.323.235Zm-3.386-.621 3.182.699.085-.391-3.181-.699-.086.39ZM5.266 17.163l8.172 1.04.05-.397-8.171-1.04-.05.397Zm-.605.993.791-1.073-.322-.237-.79 1.072.32.238Zm.791.835-.791-1.073-.322.238.791 1.073.322-.238Zm7.984-1.185-8.171 1.106.053.396 8.172-1.105-.054-.397Zm-3.184 1.926-.242.764.382.121.242-.764-.382-.12Zm3.416-.48-3.246.342.042.398 3.246-.342-.042-.398Zm-2.707 1.967 2.826-1.594-.196-.348-2.826 1.593.196.349Zm-.879-.501.662.487.238-.322-.662-.487-.238.322Zm1.465 2.155.033-.813-.4-.016-.032.813.4.016Zm.643.08-.775-.276-.135.376.776.277.134-.377Zm2.048-2.339-2.26 2.39.29.275 2.261-2.39-.29-.275Zm-2.779 1.622 3.004-1.3-.159-.368-3.004 1.3.16.368Zm3.858-.529-2.406 2.13.265.3 2.406-2.13-.265-.3Zm-1.059 3.177 1.373-2.942-.363-.17-1.372 2.943.362.169Zm-1.013.083.824.032.016-.4-.824-.032-.016.4Zm-.395-.928.21.78.386-.104-.21-.78-.386.104Zm5.008 1.955.646-3.154-.392-.08-.646 3.153.392.08Zm.582.268-.662-.471-.232.326.662.471.232-.326Zm.428-.486-.662.488.237.322.662-.488-.237-.322Zm-.755-2.934.678 3.138.39-.085-.677-3.137-.391.084Zm11.481 1.7-7.267-3.885-.189.352 7.268 3.886.188-.353Zm.106 1.493v-1.317h-.4v1.317h.4Zm-1.398.597 1.26-.407-.123-.38-1.26.406.123.38Zm-6.206-5.653 6.008 5.608.273-.292-6.008-5.608-.273.292Zm-2.41 1.695 1.632 2.748.344-.204-1.631-2.748-.345.204Zm.743 3.029-.372-3.154-.397.047.371 3.154.398-.047Zm.636.076-.775-.244-.12.382.775.244.12-.382Zm.264-.579-.484.65.32.24.485-.65-.32-.24Zm-4.67-2.714-3.538 7.396.361.173 3.537-7.396-.36-.173Zm-1.11 8.186 1.486-8.063-.393-.073-1.486 8.063.393.073Zm-1.395.56 1.26-.406-.123-.381-1.26.406.123.381Zm-1.013-1.145.791 1.073.322-.237-.791-1.073-.322.237Z\"></path></g></svg>",
  },
  {
    "chain": "rizon",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#44C569\"></circle><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.266 10.902c.158 0 .158-.158.158-.158l.158-.158 7.597-4.413c.475-.315 1.108-.473 1.741-.473s1.267.158 1.741.473c0 0 7.44 4.256 7.597 4.256.634.315 1.108.945 1.267 1.733 0 .045.012.114.027.194.037.205.087.481-.027.595H26.942c-.238 0-.475-.04-.712-.08-.238-.039-.475-.078-.713-.078-.316 0-.633-.04-.95-.079a7.715 7.715 0 0 0-.949-.079c-.475-.079-.95-.118-1.424-.157-.475-.04-.95-.08-1.425-.158-1.108-.158-2.216-.315-3.323-.315-1.109-.158-2.217-.315-3.324-.315-.475-.08-.95-.119-1.425-.158-.475-.04-.95-.079-1.424-.158-.317 0-.633-.039-.95-.078a7.715 7.715 0 0 0-.95-.08H8.74c-.158 0-.158 0-.316-.157-.08 0-.119 0-.139-.02-.02-.02-.02-.059-.02-.137Zm20.26 13.24s0 .157-.16.157v.157c-.104.105-.192.21-.28.315-.176.21-.352.42-.669.631l-7.755 4.413c-.475.316-1.108.473-1.741.473s-1.266-.157-1.741-.473l-6.806-3.94c-.158 0-.158-.158-.158-.158-.091-.09-.13-.129-.146-.175-.012-.035-.012-.073-.012-.14.158-.315.633-.315.633-.315h.633c.316 0 .475 0 .791-.158.317 0 .475 0 .791-.157h.001c.95-.158 1.899-.316 2.848-.316.456-.075.911-.114 1.349-.152.475-.041.93-.08 1.342-.163.95-.157 1.9-.157 2.69-.157.497 0 .95-.044 1.383-.085.395-.037.773-.073 1.15-.073h5.54c.316 0 .474.158.474.158-.079 0-.118 0-.138.02-.02.02-.02.058-.02.137Zm.372-3.523c.102-.156.102-.378.102-.735v-2.837c0-.772-.105-.808-.317-.881-.047-.017-.1-.035-.158-.064h-.158c-6.964-1.734-12.82-2.522-18.202-2.522H9.058C7.317 13.738 7 13.895 7 14.84v6.463c0 .315 0 .63.158.788.118.234.322.208.549.178.079-.01.16-.02.243-.02H10.957c1.424 0 2.849 0 4.273-.158 3.166-.157 6.49-.473 9.655-.788h.95l1.266-.158c1.183-.196 1.629-.27 1.797-.526Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "axelar",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#axelar_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#fff\"></path><path d=\"M19.395 16.105 26.72 8.78 23.94 6l-5.936 5.936L12.069 6l-2.78 2.78 7.327 7.325c.383.384.886.576 1.389.576a1.96 1.96 0 0 0 1.39-.576ZM30 23.931l-5.936-5.936L30 12.059l-2.78-2.78-7.325 7.326a1.965 1.965 0 0 0 0 2.78l7.326 7.325L30 23.931Zm-12.005.133L23.93 30l2.78-2.78-7.326-7.325a1.965 1.965 0 0 0-2.78 0L9.28 27.22 12.06 30l5.936-5.936Zm-1.89-4.67a1.965 1.965 0 0 0 0-2.778L8.78 9.29 6 12.069l5.936 5.936L6 23.941l2.78 2.78 7.325-7.326Z\" fill=\"#000\"></path></g><defs><clipPath id=\"axelar_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "omniflix",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#omniflix_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#000\"></path><path d=\"m13.847 24.407-.287.165v-.33s-.003.169.073.211c.075.041.214-.046.214-.046Z\" fill=\"#8E3315\"></path><path d=\"M6.509 24.068a12.993 12.993 0 0 0 7.663 6.334 13.023 13.023 0 0 0 9.907-.93 12.983 12.983 0 0 0 6.346-7.649 12.956 12.956 0 0 0-.937-9.888c1.453 4.572-3.607 6.179-3.607 6.179l-6.124 3.194-6.365 3.314s-4.337 2.787-6.883-.554Z\" fill=\"#473ADE\"></path><path d=\"M6.486 24.091a12.993 12.993 0 0 0 7.664 6.334 13.023 13.023 0 0 0 9.906-.93 12.983 12.983 0 0 0 6.347-7.648 12.953 12.953 0 0 0-.931-9.888c1.453 4.572-3.614 6.178-3.614 6.178l-6.123 3.195-6.365 3.313s-4.338 2.787-6.884-.554Z\" fill=\"url(#omniflix_svg__b)\"></path><path d=\"m25.718 17.797.472.23-.499.2s.215-.102.24-.2c.025-.098-.213-.23-.213-.23Z\" fill=\"#251E73\"></path><path d=\"M29.566 23.933a12.953 12.953 0 0 0 .808-9.899 12.983 12.983 0 0 0-6.44-7.57 13.023 13.023 0 0 0-9.918-.807 12.993 12.993 0 0 0-7.584 6.428c2.92-3.809 7.143-.585 7.143-.585l6.133 3.178 6.368 3.307s4.774 1.95 3.49 5.948Z\" fill=\"#D71D6A\"></path><path d=\"M29.535 23.921a12.915 12.915 0 0 0 .806-9.869 12.945 12.945 0 0 0-6.422-7.547 12.984 12.984 0 0 0-9.888-.805 12.954 12.954 0 0 0-7.561 6.41c2.912-3.798 7.122-.584 7.122-.584l6.114 3.168 6.35 3.297s4.759 1.945 3.48 5.93Z\" fill=\"url(#omniflix_svg__c)\"></path><path d=\"m13.563 11.806-.005-.345.302.168s-.153-.09-.23-.041c-.076.047-.067.219-.067.219Z\" fill=\"#741039\"></path><path d=\"M18 5.031a13.012 13.012 0 0 0-9.192 3.801A12.964 12.964 0 0 0 5 18.008c0 3.441 1.37 6.742 3.808 9.175a12.995 12.995 0 0 0 9.187 3.795c-4.425-.742-4.42-6.458-4.42-6.458V11.38s0-5.558 4.425-6.349Z\" fill=\"#FF5B25\"></path><path d=\"M18 5a13.012 13.012 0 0 0-9.192 3.8A12.964 12.964 0 0 0 5 17.977c0 3.442 1.37 6.743 3.808 9.176a13.025 13.025 0 0 0 9.187 3.825c-4.425-1.41-4.42-6.45-4.42-6.45V11.5S13.414 5.84 18 5Z\" fill=\"url(#omniflix_svg__d)\"></path><path d=\"M18 5a13.012 13.012 0 0 0-9.192 3.8A12.964 12.964 0 0 0 5 17.977c0 3.442 1.37 6.743 3.808 9.176a13.025 13.025 0 0 0 9.187 3.825c-4.425-1.41-4.42-6.45-4.42-6.45V11.5S13.414 5.84 18 5Z\" fill=\"url(#omniflix_svg__e)\" fill-opacity=\"0.3\"></path><path d=\"M17.996 30.975c-4.39-1.996-4.415-6.452-4.415-6.452s-5.442 3.064-7.274-.855c0 0 3.1 7.333 11.69 7.307Z\" fill=\"#473ADE\"></path></g><defs><linearGradient id=\"omniflix_svg__b\" x1=\"29.473\" y1=\"16.528\" x2=\"10.593\" y2=\"35.204\" gradientUnits=\"userSpaceOnUse\"><stop stop-opacity=\"0.6\"></stop><stop offset=\"0.656\" stop-opacity=\"0\"></stop></linearGradient><linearGradient id=\"omniflix_svg__c\" x1=\"10.209\" y1=\"9.498\" x2=\"36.273\" y2=\"14.289\" gradientUnits=\"userSpaceOnUse\"><stop stop-opacity=\"0.6\"></stop><stop offset=\"0.646\" stop-opacity=\"0\"></stop></linearGradient><linearGradient id=\"omniflix_svg__d\" x1=\"11.962\" y1=\"29.346\" x2=\"4.254\" y2=\"5.561\" gradientUnits=\"userSpaceOnUse\"><stop stop-opacity=\"0.6\"></stop><stop offset=\"0.675\" stop-opacity=\"0\"></stop></linearGradient><linearGradient id=\"omniflix_svg__e\" x1=\"11.962\" y1=\"29.346\" x2=\"4.254\" y2=\"5.561\" gradientUnits=\"userSpaceOnUse\"><stop stop-opacity=\"0.6\"></stop><stop offset=\"0.675\" stop-opacity=\"0\"></stop></linearGradient><clipPath id=\"omniflix_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "passage",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#passage_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M34.443 17.988c0-9.091-7.37-16.432-16.443-16.432-9.097 0-16.443 7.34-16.443 16.407S8.903 34.42 18 34.42c9.097 0 16.443-7.341 16.443-16.432ZM10.995 1.434A17.793 17.793 0 0 1 18 0c2.408 0 4.792.486 7.005 1.41 2.14.9 4.087 2.212 5.717 3.865a18.255 18.255 0 0 1 3.867 5.712 18.176 18.176 0 0 1 1.411 7 17.97 17.97 0 0 1-5.278 12.714 18.27 18.27 0 0 1-5.717 3.865A17.793 17.793 0 0 1 18 36a18.202 18.202 0 0 1-12.722-5.275 18.975 18.975 0 0 1-3.867-5.712 18.175 18.175 0 0 1-1.411-7c0-4.79 1.897-9.36 5.278-12.714a18.27 18.27 0 0 1 5.717-3.865ZM3.55 17.961c0-7.973 6.47-14.439 14.448-14.439 8.003 0 14.473 6.466 14.45 14.44 0 7.972-6.471 14.438-14.45 14.438-7.978 0-14.448-6.466-14.448-14.439Zm8.075.487 2.214-2.213v-1.118a3.092 3.092 0 0 0-3.09-3.087 3.092 3.092 0 0 0-3.088 3.087v5.737a3.093 3.093 0 0 0 3.089 3.087 3.093 3.093 0 0 0 3.089-3.087v-2.406h-2.213Zm16.76 2.406v-2.358h-2.214l2.214-2.212v-1.167a3.092 3.092 0 0 0-3.09-3.087 3.092 3.092 0 0 0-3.088 3.087v5.737a3.093 3.093 0 0 0 3.089 3.087 3.093 3.093 0 0 0 3.089-3.087Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"passage_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "govgen",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#govgen_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"url(#govgen_svg__b)\"></path><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#6FD8D4\"></path><path d=\"M10.988 13.004c1.121-.028 2.27.086 3.31.53.8.355 1.567.819 2.17 1.46-.468.336-.938.67-1.406 1.005-.49-.565-1.133-1-1.848-1.225-.607-.196-1.247-.264-1.882-.267-.929 0-1.881.13-2.718.553-.48.243-.919.582-1.232 1.024-.486.673-.647 1.527-.63 2.344.01.773.201 1.569.68 2.19.513.67 1.295 1.087 2.1 1.302.797.211 1.631.252 2.452.203.664-.046 1.327-.17 1.945-.423a3.006 3.006 0 0 0 1.406-1.166v-1.147h-4.192v-1.479h5.856c-.002 1.062.005 2.125-.003 3.187-.475.777-1.221 1.352-2.02 1.768-1.027.54-2.194.753-3.344.782-1.152.027-2.325-.092-3.405-.512-.873-.338-1.678-.887-2.244-1.64-.579-.753-.891-1.687-.962-2.629-.081-1.066.062-2.178.576-3.128a4.697 4.697 0 0 1 1.894-1.882c1.064-.591 2.291-.819 3.497-.85ZM24.988 13.004c1.121-.028 2.27.086 3.31.53.8.355 1.567.819 2.17 1.46-.468.336-.938.67-1.406 1.005-.49-.565-1.133-1-1.848-1.225-.607-.196-1.247-.264-1.882-.267-.929 0-1.881.13-2.718.553-.48.243-.919.582-1.232 1.024-.486.673-.647 1.527-.63 2.344.01.773.201 1.569.68 2.19.513.67 1.295 1.087 2.1 1.302.797.211 1.631.252 2.452.203.664-.046 1.327-.17 1.945-.423a3.006 3.006 0 0 0 1.406-1.166v-1.147h-4.192v-1.479h5.856c-.002 1.062.005 2.125-.003 3.187-.475.777-1.221 1.352-2.02 1.768-1.027.54-2.194.753-3.344.782-1.152.027-2.325-.092-3.405-.512-.873-.338-1.678-.887-2.244-1.64-.579-.753-.891-1.687-.962-2.629-.081-1.066.062-2.178.576-3.128a4.698 4.698 0 0 1 1.894-1.882c1.064-.591 2.291-.819 3.497-.85Z\" fill=\"#000\"></path></g><defs><linearGradient id=\"govgen_svg__b\" x1=\"0\" y1=\"18\" x2=\"36\" y2=\"18\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#D1E9CC\"></stop><stop offset=\"1\" stop-color=\"#03C5DC\"></stop></linearGradient><clipPath id=\"govgen_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
  {
    "chain": "kusama",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#1D1D1D\"></circle><path d=\"M28.644 10.829c-.45-.408-.95-.714-1.55-.816-.75-.102-1.5.408-2 .765-.499.357-1.499 1.274-1.899 1.631-.4.357-1.4.56-3.049 1.58-1.65 1.02-8.048 5.2-8.048 5.2h1.65L6.3 23.114h.75L6 23.93c.6.152 1.2.05 1.75-.255v.255s8.847-3.569 10.547-2.651l-1.05.306c.1 0 1.75.102 1.75.102.1.713.5 1.376 1.1 1.733.999.662 1.049 1.07 1.049 1.07s-.5.204-.5.51a4.537 4.537 0 0 1 2.85 0s-.05-.306-.75-.51c-.7-.306-1.3-.764-1.75-1.427-.4-.56-.55-1.274-.3-1.937.25-.663 1.1-1.02 2.85-1.937 2.049-1.07 2.549-1.886 2.799-2.549s.75-1.886.95-2.498c.2-.56.55-1.02 1-1.427.549-.306 1.149-.56 1.699-.765.1.051-1-.866-1.35-1.121Z\" fill=\"#fff\"></path></svg>",
  },
  {
    "chain": "nibiru",
    "svg": "<svg width=\"40\" height=\"40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"platform-icon\" viewBox=\"0 0 36 36\"><g clip-path=\"url(#nibiru_svg__a)\"><path d=\"M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18Z\" fill=\"#6F55D7\"></path><path d=\"m18.348 5.495.56-.803-.56-.391-.56.391.56.803Zm-7.658 5.349-.56-.803-1.13.79 1.117.806.573-.793Zm15.316 0h.979v-.51l-.419-.293-.56.803Zm0 11.055-.573.793 1.552 1.12V21.9h-.98Zm-.681 3.21.57.794L27 25.11l-1.102-.795-.573.793ZM10.01 14.052l.572-.793-1.551-1.12v1.913h.979Zm7.864 16.404-.55.81.565.384.556-.399-.57-.794Zm-7.864-5.349h-.98v.518l.43.291.55-.809Zm7.778-20.416-7.658 5.35 1.12 1.604 7.659-5.35-1.121-1.604Zm8.778 5.35-7.657-5.35-1.121 1.605 7.658 5.349 1.12-1.605Zm.419 11.857V10.844h-1.958v11.055h1.958ZM10.118 11.637l15.315 11.055 1.146-1.587L11.263 10.05l-1.146 1.587Zm15.78 12.678L10.582 13.26l-1.145 1.587 15.315 11.055 1.146-1.587Zm-7.453 6.937 7.45-5.349-1.14-1.59-7.451 5.35 1.14 1.59Zm-8.986-5.335 7.865 5.35 1.1-1.619L10.56 24.3l-1.1 1.618Zm-.428-11.864v11.055h1.957V14.053H9.031Z\" fill=\"#fff\"></path></g><defs><clipPath id=\"nibiru_svg__a\"><path fill=\"#fff\" d=\"M0 0h36v36H0z\"></path></clipPath></defs></svg>",
  },
]

export const etherscanSupportedChains = [
  "0x1",
  "0x5",
  "0xAA36A7",
  "0x4268",
  "0x38",
  "0x61",
  "0xCC",
  "0x15EB",
  "0xFA",
  "0xFA2",
  "0xA",
  "0x1A4",
  "0xAA37DC",
  "0x89",
  "0x13881",
  "0xA4B1",
  "0x66EEE",
  "0x504",
  "0x507",
  "0x505",
  "0xC7",
  "0x404",
  "0xA4EC",
  "0xAEF3",
  "0x64",
  "0xA4BA",
  "0x2105",
  "0x14A34",
  "0x44D",
  "0x5A2",
  "0xE708",
  "0xE704",
  "0x82750",
  "0x8274F",
  "0x457",
  "0x458",
  "0xFF",
  "0x936",
  "0x144",
  "0x12C",
  "0xFC",
  "0x9DA",
  "0xA86A",
  "0xA869",
  "0x13E31",
  "0x5D50",
]

export const scannerConfig = [
  {
    id: "0x1",
    website: "https://etherscan.io/",
    name: "Etherscan",
  },
  {
    id: "0x38",
    website: "https://bscscan.com/",
    name: "BscScan",
  },
  {
    id: "0x89",
    website: "https://polygonscan.com/",
    name: "PolygonScan",
  },
  {
    id: "0xA86A",
    website: "https://snowscan.xyz/",
    name: "SnowScan",
  },
  {
    id: "0x2105",
    website: "https://basescan.org/",
    name: "BaseScan",
  },
  {
    id: "0xA4B1",
    website: "https://arbiscan.io/",
    name: "ArbiScan",
  },
  {
    id: "0xA",
    website: "https://optimistic.etherscan.io/",
    name: "Optimism",
  },
  {
    id: "0xFA",
    website: "https://ftmscan.com/",
    name: "FtmScan",
  },
  {
    id: "0xCC",
    website: "https://opbnb.bscscan.com/",
    name: "opBNB",
  },
  {
    id: "0x64",
    website: "https://gnosisscan.io/",
    name: "GnosisScan",
  },
  {
    id: "0x504",
    website: "https://moonscan.io/",
    name: "MoonScan",
  },
  {
    id: "0x505",
    website: "https://moonriver.moonscan.io/",
    name: "Moonriver",
  },
]

export const supportedChainsConfig = chainUrls.flatMap(chain => {
  const image = chainImgs.find(img => img.chain.toLowerCase() === chain.name.toLowerCase())
  const scanner = scannerConfig.find(scan => scan.id.toLowerCase() === chain.id.toLowerCase())?.website

  if (!image || !scanner) {
    return []
  }

  return {
    scanner,
    ...chain,
    ...image,
  }
})
